/*
 * Init
 */
var offlineIdUrlParam = window.location.href.match(/&offline-id=(\d+)/);
var OFFLINEID = offlineIdUrlParam ? +offlineIdUrlParam[1] : -1;

// Set by loadData, also used by attachment drawing.
var matrixQuestionId;
var matrixLineId;

var indexParam = window.location.href.match(/&index=(-?\d+)/);
var isMatrix = !!indexParam;
var isSurvey = false;

var formWidth;
var globalInit = true;
var selectedAction = null;
var matrixUndo = null;
var changedDrawings = {};
var matrixAttachments = {};
var matrixActions = [];

let savedFormData;

// Object to track files for each upload control.
const uploadFileTrackers = {};

var matrixConfig = {
    dataBound: resetMatrixHeader,
    resizable: true,
    selectable: true,
    change: handleMatrixSelect
};

var matrixConnectedFormsConfig = {
    resizable: true,
    filterable: gridFilterOptions,
    filterMenuInit: leanformsNext.updateSearchFilterMenu,
    sortable: true,
    selectable: false
};

const datePickerMap = {
    "datepicker": "kendoDatePicker",
    "datetimepicker": "kendoDateTimePicker",
    "timepicker": "kendoTimePicker"
};

const typeIdMap = {
    "0": "date",
    "1": "time",
    "2": "both"
};

resetDatasetLinkbuttons();

$(function () {
    formWidth = $(document).width();

    var $body = $("body");

    $body.on("keydown", function (e) {
        if (e.keyCode == 13 && (e.target.nodeName !== "A" && e.target.nodeName !== "TEXTAREA" && $(e.target).attr("data-role") !== "upload")) {
            e.preventDefault();
        }
    });

    document.documentElement.focus();

    // Initial setup for each matrix.
    $(".matrix-div").on("click", ".matrix-duplicate-button", duplicateMatrixLine);

    $(".matrix-div").each(function () {
        const matrixGrid = $(this).find("[data-role='grid']").data("kendoGrid");

        if (matrixGrid) {
            initMatrixEvents(matrixGrid);
        }

        // Ensure duplicate button state is properly initialized for empty matrices.
        const dataInput = $(this).find("textarea[type=matrix]");
        if (dataInput.length > 0) {
            const dataInputId = dataInput.attr("id");
            const allowDuplicateLine = dataInput.data("allowDuplicate");
            const matrixAddIsEnabled = $(this).find(".matrixAdd").is(":visible");

            if (allowDuplicateLine && matrixAddIsEnabled) {
                const matrixData = dataInput.val() || "";
                const lineCount = matrixData.indexOf("line id") >= 0 ?
                    (matrixData.match(/line id=/g) || []).length : 0;

                const duplicateButton = $(this).find(".matrix-duplicate-button");
                const enableDuplicateButton = lineCount > 0;
                duplicateButton.prop("disabled", !enableDuplicateButton).removeClass("hidden");
            }
        }
    });

    setTimeout(function () {
        createUploads();
    }, 0);

    if (FORMID !== "-1") {
        setTimeout(function () {
            initActionsGrid({ id: FORMID });
        }, 0);
    }

    if (!core.supportsOffline() || $body.hasClass("frame-master")) {
        $("#btnToggleOffline").parent().hide();
    }
    else {
        if (!isMatrix) {
            indexedDatabase.formTypeUsers
                .where({ userId: USERID, formTypeBaseId: +BASEID })
                .first(function (formTypeOffline) {
                    if (formTypeOffline) {
                        toggleOfflineLabel(true);
                    }
                });
        }

        if (!window.navigator.onLine) {
            $("input.dataset").parent().after("<p class=\"dataset-offline-warning\">" + resources.datasetOfflineWarning + "</p>");
        }
    }

    // Find the warning bar. No bar, no need to observe resizing.
    const warningBar = document.querySelector('.warning-bar');
    if (warningBar) {
        const fixedHeader = document.querySelector('.form-fixed-header');
        const observer = new ResizeObserver((entries) => {
            // First entry is the component itself as that is where the resize observer is attached to.
            const barHeight = entries[0].target.offsetHeight
            if (barHeight > 0) {
                fixedHeader.style.insetBlockStart = `${barHeight}px`;
            }
            else {
                fixedHeader.style.insetBlockStart = '0';
            }
        });
        observer.observe(warningBar, { box: 'border-box' });
    }
});

/*
 * Misc UI actions
 */
function openInfo(q, title) {
    if ($("#dialog_" + q).length > 0) {
        $("#dialog_" + q).data("kendoWindow").toFront();
        return false;
    }

    // Sanitized server side.
    var infoContent = $("#info_" + q).html();
    $("#windowcontainer").append("<div id=\"dialog_" + q + "\"><div class=\'info-content\'>" + infoContent + "</div></div>");
    $("body").css("overflow", "hidden");
    $("#dialog_" + q).kendoWindow({
        width: coreUI.getPopupWidth(800),
        height: coreUI.getPopupHeight(650),
        title: `${resources.viewForm.extraInfo}${title}`,
        visible: false,
        modal: true,
        close: function () {
            $("body").css("overflow", "");
        },
        deactivate: function () {
            this.destroy();
        }
    }).data("kendoWindow").center().open();
}

function delForm() {
    formControls.showOldConfirmDialog(
        resources.confirmDeleteTitle,
        resources.confirmDeleteMessage,
        function (dialogResult, serializedFormData) {
            if (dialogResult !== "OK") {
                return;
            }

            $("#deleteFormConfirmation").val(serializedFormData);
            const form = document.querySelector("form");
            form?.setAttribute("action", `${baseUrl}/ViewForm?handler=Delete&FormGuid=${FORMGUID}`);
            form?.submit();
        }
    );
}

function toggleFavorite(e) {
    var $this = $(this);
    var action = $this.hasClass("lf-icon-star-outline") ? "POST" : "DELETE";

    $.ajax({
        url: baseUrl + "/api/favorites?type=form&targetId=" + BASEID,
        type: action,
        error: leanformsNext.onAjaxError,
        success: function () {
            $this.toggleClass("lf-icon-star lf-icon-star-outline");
        }
    });
}

var stepChanged = false;
function showRoute() {
    if (!$("#windowcontainer").find("#dialog").length) {
        var win = $("<div id=\"dialog\" class=\"show-route-dialog\"></div>");
        $("#windowcontainer").append(win);
    }

    $("body").css("overflow", "hidden");

    $("#dialog").kendoWindow({
        visible: false,
        height: coreUI.getPopupHeight("90%"),
        width: coreUI.getPopupWidth("95%"),
        title: resources.viewForm.routeTitle,
        modal: true,
        iframe: true,
        content: baseUrl + "/FormViews/DesignRoute?FormGuid=" + FORMGUID,
        resizable: true,
        close: function () {
            $("body").css("overflow", "");

            if (stepChanged) {
                location.reload();
            }
        },
        deactivate: function () {
            this.destroy();
        }
    }).data("kendoWindow").center().open();
}

/*
 * Numeric input touchscreen helper buttons.
 */
var needsHelperButtons = /Android|iPhone|iPod/i.test(window.navigator.userAgent);
$(document.body).toggleClass("show-helper-buttons", needsHelperButtons);
$(".numeric-helper-button").on("click", function () {
    var input = $(this).prevAll("input");
    var add = $(this).text();
    var val = input.val();
    var vanillaInput = input.get(0)
    var cursorPosition = vanillaInput.selectionStart;
    var beforeCursor = val.slice(0, cursorPosition);
    var afterCursor = val.slice(cursorPosition);
    var newCursorPosition = cursorPosition + 1;

    input.val(beforeCursor + add + afterCursor).focus();
    vanillaInput.setSelectionRange(newCursorPosition, newCursorPosition);
});

/*
 * Checkbox un-check helper.
 */
function toggleCheckbox(a, b) {
    $("#" + b).prop("checked", !$(a).prop("checked"));
}

/*
 * Copy from other question.
 */
function copyCheckbox(src, trg, beforesave) {
    var target = trg.split(";")
    var update;

    for (var k = 0; k < target.length; k++) {
        update = true;

        if (beforesave) {
            update = false;

            $("input[name^=\"" + src + "#\"]").each(function () {
                var item = $(this).attr("name").split("#")[1];

                if ($("input[name^=\"" + target[k] + "#" + item + "\"]").is(":disabled")) {
                    $("input[name^=\"" + target[k] + "#" + item + "\"]").removeAttr("disabled");
                }

                update = true;
            });

            if ($("#id_" + target[k]).is(":disabled")) {
                $("#id_" + target[k]).removeAttr("disabled");

                update = true;
            }
        }

        if (update) {
            $("input[name^=\"" + src + "#\"]").each(function () {
                var item = $(this).attr("name").split("#")[1];
                $("input[name^=\"" + target[k] + "#" + item + "\"]").prop("checked", $(this).is(":checked"));
            });

            $("#id_" + target[k]).prop("checked", $(this).is(":checked"));
        }
    }
}

function handleCopyCheckbox(src, trg) {
    $("input[name^=\"" + src + "#\"]").each(function () {
        $(this).change(function () {
            copyCheckbox(src, trg, false);
        })
    });

    $("#id_" + src).change(function () {
        copyCheckbox(src, trg, false);
    })
}

function copyFields(sourceId, targetList, isBeforeSave) {
    var sourceElement = $("#id_" + sourceId);
    var sourceValue = sourceElement.val();
    var targetIds = targetList.split(";");

    for (var i = 0; i < targetIds.length; i++) {
        var targetId = targetIds[i];
        var update = true;
        var targetElement = $("#id_" + targetId);

        if (isBeforeSave) {
            if (targetElement.is(":disabled")) {
                targetElement.removeAttr("disabled");
            }
            else {
                update = false;
            }
        }

        if (update) {
            loadData({
                isFieldCopy: true,
                data: [{
                    name: targetId,
                    value: sourceValue,
                    sourceElement: sourceElement
                }]
            });
        }
    }
}

function handleCopy(sourceId, targetList) {
    $("#id_" + sourceId).change(function () {
        copyFields(sourceId, targetList, false);
    });
}

/*
 * Drawing on attachment 
 */
var attachmentDrawing = (function () {
    var htmlEls = $(document.documentElement).add(window.top.document.documentElement);
    var attachmentDrawingContainer = $(".attachment-draw-container");
    var canvasElement = $(".attachment-draw-canvas");
    var sizeHelper = $(".attachment-draw-size-helper");
    var undoButton = $(".attachment-draw-undo");
    var closeButton = $(".attachment-draw-close");
    var confirmButton = $(".attachment-draw-confirm");
    var colorButtons = $(".attachment-draw-color");
    var defaultColorButton = colorButtons.eq(0);
    var metaViewport = window.top.document.querySelector("meta[name=viewport]");
    var sidebarToggle = window.top.$(".resize-sidebar");
    var attachmentContainer;

    var canvas = new fabric.Canvas(canvasElement.get(0), {
        renderOnAddRemove: false,
        selection: false,
        isDrawingMode: true
    });

    if (core.isIosPWA) {
        // In iOS PWA, vertical movement would not follow the pointer correctly.
        // This is the only reliable fix I could find.
        canvas.upperCanvasEl.addEventListener("touchmove", function (e) {
            e.preventDefault();
        });
    }

    canvas.freeDrawingBrush.width = 3;

    function openAttachmentDrawing() {
        canvas.clear();
        window.addEventListener("resize", resizeCanvas, { passive: true });

        // Need to do this first to get correct dimensions.
        attachmentDrawingContainer.css("visibility", "hidden");
        attachmentDrawingContainer.removeClass("hidden");

        htmlEls.addClass("is-drawing-active");
        toggleZoomPrevention(true);

        // Reset zoom so image size applies correctly.
        canvas.setViewportTransform([1, 0, 0, 1, 0, 0]);

        attachmentContainer = $(this).closest(".attachment-container");

        var imageElement = attachmentContainer.find(".attachment-image").get(0);
        var width = imageElement.naturalWidth;
        var height = imageElement.naturalHeight;
        var fabricImage = new fabric.Image(imageElement, {
            width: width,
            height: height
        });

        sizeHelper.attr("src", imageElement.src);

        canvas.setWidth(width);
        canvas.setHeight(height);

        canvas.add(fabricImage);
        canvas.renderAll();

        // We need some arbitrary timeout apparently.
        setTimeout(() => {
            resizeCanvas();

            attachmentDrawingContainer.css("visibility", "visible");
        }, 100);

        setColor(defaultColorButton);
    }

    async function dataUriToBlob(dataUri) {
        return await fetch(dataUri).then(res => res.blob());
    }

    function closeDrawing() {
        attachmentDrawingContainer.addClass("hidden");

        htmlEls.removeClass("is-drawing-active");
        toggleZoomPrevention(false);

        window.removeEventListener("resize", resizeCanvas, { passive: true });
    }

    async function closeAttachmentDrawing() {
        attachmentDrawingContainer.addClass("hidden");

        htmlEls.removeClass("is-drawing-active");
        toggleZoomPrevention(false);

        window.removeEventListener("resize", resizeCanvas, { passive: true });

        // No need to upload when no (new) drawing is present.
        var hasDrawnPaths = canvas.getObjects().length > 1;
        if (!hasDrawnPaths) {
            return;
        }

        var dataUri = canvas.toDataURL({ format: "jpeg" });
        var imageBlob = await dataUriToBlob(dataUri);
        var file = new File([imageBlob], "image-with-drawing.jpg");

        attachmentContainer
            .find(".attachment-image")
            .attr("src", dataUri);

        var offlineId = attachmentContainer.data("offline-id");
        var wasSavedOffline = offlineId > 0;

        if (wasSavedOffline) {
            db.attachments.update(offlineId, {
                data: file,
            }).catch(function (err) {
                if (!handlePotentialQuotaError(err)) {
                    leanformsNext.handleError(err);
                }
            });
            // TODO update link?

            return;
        }

        var previousState = attachmentContainer.data("state");
        var wasSaved = previousState === "saved";
        var previousGuid = attachmentContainer.data("guid");
        var filename = attachmentContainer.data("filename");
        var questionId = attachmentContainer.data("question");

        if (wasSaved) {
            // If immediate online save fails,
            // This is used by hasMissingAttachments() to retry on form save.
            attachmentContainer.data("needsDrawingUpdate", true);
        }
        else {
            // Will make sure that save if retried on form save if it fails now.
            // This has a small chance of leaving orphaned attachments in the /temp/ folder.
            attachmentContainer.removeData("guid");
        }

        attachmentContainer.data("file", file);

        var attachmentFormData = new FormData();
        attachmentFormData.append("data", file);

        var uploadUrl = baseUrl + "/api/attachments/" + questionId;
        var method;

        if (wasSaved) {
            if (isMatrix) {
                attachmentFormData.append("isFromMatrix", true);
                attachmentFormData.append("matrixQuestionId", matrixQuestionId);
                attachmentFormData.append("matrixLineId", matrixLineId);
            }

            attachmentFormData.append("filename", filename);
            attachmentFormData.append("formId", FORMID);

            method = "PUT";
        }
        else {
            attachmentFormData.append("previousGuid", previousGuid);

            method = "POST";
        }

        var uploadXHR = new XMLHttpRequest();

        uploadXHR.addEventListener("load", onUploadLoadFactory(attachmentContainer, wasSaved), false);
        uploadXHR.addEventListener("error", onUploadError, false);

        uploadXHR.open(method, uploadUrl, true);
        uploadXHR.send(attachmentFormData);
    }

    function onUploadLoadFactory(container, wasSaved) {
        return function onUploadLoad() {
            if (this.status !== 200) {
                leanformsNext.handleError(this);

                return;
            }

            var uploaded = JSON.parse(this.response);
            var newGuid = uploaded.guid;

            container.data("guid", newGuid);

            var link = container.find("a");
            var displayName = container.find(".attachment-text").text();
            var newUrl = baseUrl + uploaded.url + "&displayName=" + encodeURIComponent(displayName);

            link.attr("href", newUrl);

            if (wasSaved) {
                container.data("filename", uploaded.filename);
                container.removeData("needsDrawingUpdate");

                if (isMatrix) {
                    // TODO: Update matrix xml to make sure it keeps working even if they don't save the matrix line.
                }
            }
        }
    }

    function onUploadError() {
        // Error is likely due to being offline and can be ignored, save will be retried by hasMissingAttachments().
        // Download link may be wrong until that happens.
    }

    closeButton.on("click", closeDrawing);
    confirmButton.on("click", closeAttachmentDrawing);
    colorButtons.on("click", function () {
        setColor($(this));
    });

    function setColor(colorButton) {
        colorButtons.removeClass("is-active");
        colorButton.addClass("is-active");

        var color = colorButton.css("backgroundColor");

        canvas.freeDrawingBrush.color = color;
    }

    function resizeCanvas() {
        var width = sizeHelper.width();
        var height = sizeHelper.height();
        var canvasWidth = canvas.getWidth();

        var scale = width / canvasWidth;
        var zoom = canvas.getZoom();

        zoom *= scale;

        canvas.freeDrawingBrush.width = 3 / zoom;
        canvas.setDimensions({ width: width, height: height });
        canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
    }

    var disableZoomPrevention = false;

    function toggleZoomPrevention(state) {
        if (disableZoomPrevention) {
            return;
        }

        var preventScale = ", maximum-scale=1";
        var hasPreventScale = metaViewport.content.includes(preventScale);

        if (state && hasPreventScale) {
            // Is iPhone, where zoom should always be prevented due to automatic zooming.
            disableZoomPrevention = true;

            return;
        }

        if (state) {
            metaViewport.content += preventScale;
        } else if (!state) {
            metaViewport.content = metaViewport.content.replace(preventScale, "");
        }

        // Toggle also functions as forced repaint, required for meta viewport update to work.
        sidebarToggle.toggle(!state);
    }

    undoButton.on("click", function () {
        var lastItemIndex = (canvas.getObjects().length - 1);
        var item = canvas.item(lastItemIndex);

        if (item.get("type") === "path") {
            canvas.remove(item);
            canvas.renderAll();
        }
    });

    return {
        open: openAttachmentDrawing
    };
})();

/*
 * Attachments
 */
$(".form").on("click", "button.preview-attachment", leanformsNext.previewAttachment);
$(".form").on("click", "button.delete-attachment", removeAttachment);
$(".form").on("click", "button.draw-attachment", attachmentDrawing.open);

function removeAttachment() {
    var button = $(this);
    var previewContainer = button.closest(".attachment-container");

    var questionId = previewContainer.data("question");
    var guid = previewContainer.data("guid");
    var isCopy = previewContainer.data("isCopy");
    var isNewAttachment = previewContainer.data("state") === "new";
    var isSavedMatrix = !isNewAttachment && FORMGUID === "00000000-0000-0000-0000-000000000000" && parent.FORMGUID;

    if (isNewAttachment) {
        var offlineId = previewContainer.data("offline-id");
        var url = previewContainer.find("a").attr("href");

        previewContainer.remove();

        if (guid) {
            $.ajax({
                url: baseUrl + "/api/attachments/temp",
                type: "DELETE",
                data: { fileName: guid },
                error: leanformsNext.onAjaxError,
                success: function () { }
            });
        }
        else if (typeof offlineId === "number" && offlineId > -1) {
            if (url) {
                URL.revokeObjectURL(url);
            }

            indexedDatabase.attachments.delete(offlineId).catch(leanformsNext.handleError);
        }
    }
    else if (isSavedMatrix) {
        previewContainer.remove();
    }
    else {
        var fileName = previewContainer.data("filename");

        formControls.showConfirmDialog(resources.confirmRemoveAttachment, function () {
            if (isCopy && FORMGUID === "00000000-0000-0000-0000-000000000000") {
                removeCopiedAttachments(questionId, fileName);
                previewContainer.remove();
            }
            else {
                $.ajax({
                    url: baseUrl + "/api/attachments",
                    type: "DELETE",
                    data: {
                        fileName: fileName,
                        guid: FORMGUID,
                        questionId: questionId
                    },
                    error: leanformsNext.onAjaxError,
                    success: function () {
                        previewContainer.remove();
                    }
                });
            }
        });
    }
}

function createUploads() {
    uploadInputs.forEach(function (questionId) {
        var input = $("#id_" + questionId);
        var isDisabled = input.prop("disabled");

        // In initialize file upload tracker array.
        uploadFileTrackers[questionId] = [];

        input.kendoUpload({
            async: {
                saveUrl: baseUrl + "/api/attachments/" + questionId,
                autoUpload: true
            },
            localization: {
                select: resources.attachmentsButtonText,
                dropFilesHere: resources.attachmentsDropText
            },
            select: function (e) {
                // Store selected files in the order the upload control returns them (so we can maintain order when rendering previews).
                e.files.forEach(file => uploadFileTrackers[questionId].push(file.uid));
            },
            showFileList: false,
            enabled: !isDisabled,
            success: onUploadSuccess,
            error: onUploadError
        });
    });

    // Find all created kendo uploads.
    const uploads = document.querySelectorAll('.k-upload');

    [...uploads].forEach((kendoUpload) => {
        const attachmentIcon = document.createElement('span');
        attachmentIcon.classList.add('button-icon', 'lf-icon-attach-file');

        kendoUpload.querySelector('.k-button-text').parentNode.prepend(attachmentIcon);
    });
}

function getDisplayName(currentName, questionId) {
    var existingNames = $.map(
        $("#attachments_" + questionId).find(".attachment-container"), function (attachment) {
            return $(attachment).find(".attachment-text").text();
        }
    );

    function checkName(name, i) {
        var isDuplicateName = existingNames.indexOf(name) > -1;
        if (!isDuplicateName) {
            return name;
        }

        var extensionIndex = name.lastIndexOf(".");
        var fileName = extensionIndex > -1 ? name.slice(0, extensionIndex) : name;
        var extension = extensionIndex > -1 ? name.slice(extensionIndex) : "";

        var newName = "";

        if (!i) {
            i = 1;
            newName = fileName + " (1)" + extension;
        }
        else {
            newName = fileName.replace(/^(.*)( \(\d+\))$/, "$1 (" + i + ")") + extension;
        }

        return checkName(newName, i + 1);
    }

    return checkName(currentName);
}

function onUploadSuccess(e) {
    if (e.operation !== "upload") {
        return;
    }

    const questionId = this.name;

    e.files.forEach(function (file) {
        var displayName = getDisplayName(e.response.displayName, questionId);

        createPreviewElement({
            url: baseUrl + e.response.url + "&displayName=" + encodeURIComponent(displayName),
            displayName: displayName,
            questionId: questionId,
            guid: e.response.guid,
            uid: file.uid,
            file: file.rawFile,
            state: "new"
        });
    });
}

function onUploadError(e) {
    var response = e.XMLHttpRequest;

    // Catch specific upload failed error.
    if (e.operation === 'upload' && JSON.parse(response.responseText) === 'No file provided') {
        e.preventDefault();

        const upload = $(e.sender.element).data('kendoUpload');

        // Remove file entry?
        //const fileList = upload.wrapper.find(".k-file");
        //const currentFile = fileList.filter("[data-uid='" + e.uid + "']");
        //currentFile.remove();

        // Hide success status.
        upload.wrapper.find(".k-upload-status").addClass('hidden');

        return core.notify('error', resources.viewForm.noFile);
    }

    if (FORMID !== "-1" || e.operation !== "upload" || response.status !== 0 || !core.supportsOffline()) {
        // TODO: show error.
        return;
    }

    e.preventDefault();

    var questionId = e.sender.name;
    var kendoFile = e.files[0];
    var fileName = kendoFile.name;
    var file = kendoFile.rawFile;
    var displayName = getDisplayName(fileName, questionId);
    var url = "";

    if (coreUI.isImage(fileName)) {
        url = getOfflineUrl(file);
    }

    var previewEl = createPreviewElement({
        url: url,
        displayName: displayName,
        questionId: questionId,
        file: file,
        uid: kendoFile.uid,
        offline: true,
        state: "new"
    });

    if (isMatrix) {
        return;
    }

    indexedDatabase.attachments.add({
        type: "file",
        data: file,
        displayName: displayName,
        questionId: questionId
    }).then(function (id) {
        previewEl.data("offline-id", id);
    });
}

function createPreviewElement(options) {
    var src = options.url;
    var offlineId = options.offlineId;
    var fileName = options.fileName;
    var displayName = options.displayName;
    var guid = options.guid;
    var file = options.file;
    var questionId = options.questionId;
    var state = options.state;
    var step = options.step;
    var offlineFormSaved = options.offlineFormSaved;
    var isDatasetValue = options.isDatasetValue;
    var isCopy = options.isCopy;
    var datasetField = options.datasetField;

    var previewContainer = $("#attachments_" + questionId);

    if (!previewContainer.length) {
        var canvas = $("#C_" + questionId);

        canvas
            .data("state", state)
            .data("filename", fileName);

        return;
    }

    var container = $("<div class=\"attachment-container\">")
        .data("state", state)
        .data("question", questionId);

    if (guid) {
        container.data("guid", guid);
    }

    if (file) {
        container.data("file", file);
    }

    if (isDatasetValue) {
        container.data("isDatasetValue", isDatasetValue);
    }

    if (isCopy) {
        container.data("isCopy", isCopy);
    }

    if (datasetField) {
        container.data("datasetField", datasetField);
    }

    if (fileName) {
        container.data("filename", fileName);
    }

    if (step) {
        container.data("step", step);
    }

    if (offlineFormSaved) {
        container.data("offline-saved", offlineFormSaved);
    }

    if (typeof offlineId !== "undefined") {
        container.data("offline-id", offlineId);
    }

    var attachmentItem = $("<div class=\"attachment-item\">");
    var buttons = $("<div class=\"attachment-buttons\">");

    if (coreUI.isImage(displayName)) {
        attachmentItem.append(`<img class="attachment-image" src="${src}" />`);
        buttons.append(`
            <button type="button" class="button button-icon-only preview-attachment" title="${resources.attachmentPreview.preview}">
                <span class="button-icon lf-icon-zoom-in"></span>
            </button>`);

        if (!isDatasetValue && !isCopy) {
            buttons.append(`
                <button type="button" class="button button-icon-only draw-attachment" title="${resources.drawOnAttachmentText}">
                    <span class="button-icon lf-icon-brush"></span>
                </button>`);
        }
    }
    else if (displayName.endsWith("pdf")) {
        attachmentItem.append("<span class=\"attachment-icon lf-icon-file-pdf custom\"></span>");
        buttons.append(`
            <button type="button" class="button button-icon-only preview-attachment" title="${resources.attachmentPreview.preview}">
                <span class="button-icon lf-icon-zoom-in"></span>
            </button>`);
    }
    else {
        attachmentItem.append(`<span class="attachment-icon lf-icon-file-${core.getFileIconSuffix(displayName)}"></span>`);
    }

    var deleteButton = `
        <button type="button" class="button button-icon-only delete-attachment" title="${resources.attachmentPreview.delete}">
            <span class="button-icon lf-icon-delete"></span>
        </button>`;

    if (state === "new" || step === currentStep || currentStep === "-1") {
        buttons.append(deleteButton);
    }

    attachmentItem.append(buttons);
    attachmentItem.append('</div>');
    container.append(attachmentItem);

    var filenameText = displayName.replace(/^\d+_\d+_(.*)/, "$1");
    var text = $(`<a download onclick="downloadFile(event)" class="attachment-text display-name" title="${resources.attachmentPreview.download}">`).attr("href", src).text(filenameText);

    container.append(text);

    // We want to maintain order when we have a uid (new upload).
    if (options.uid) {
        const tracker = uploadFileTrackers[questionId];
        const index = tracker?.indexOf(options.uid);
        const children = previewContainer.find(".attachment-container:data(index)");

        // Add the intended position on the container.
        container.data("index", index);

        // Just add to the end of the previewContainer; when a loaded form, when first, or when actual in a larger position requested.
        if (index > children.length || children.length === 0) {
            previewContainer.append(container);
        }
        else {
            // Insert the new element before the child at the target index.
            for (let element of children) {
                const jElement = $(element);
                if (jElement.data("index") > index) {
                    jElement.before(container);
                    break;
                }
            }
        }
    }
    else {
        previewContainer.append(container);
    }

    return container;
}

if (core.supportsOffline()) {
    window.navigator.serviceWorker.addEventListener("message", function (e) {
        if (e.data.message === "sync-complete") {
            // Sync removes attachments that don't have a related form.
            // Offline saved attachments which haven't been saved to the form will also be included in this.
            $(".attachment-container").each(function () {
                var preview = $(this);

                if (preview.data("offline-id") > 0 && preview.data("offline-saved") !== true) {
                    preview.removeData("offline-id");
                }
            });
        }
    });
}

/*
 * Copy from other form.
 */
function copyForm() {
    $("#windowcontainer").append("<div id=\"copydialog\"></div>");

    const width = formWidth < 900 ? "95%" : "50%";

    $("body").css("overflow", "hidden");
    $("#copydialog").kendoWindow({
        width: coreUI.getPopupWidth(width),
        height: coreUI.getPopupHeight("90%"),
        title: resources.copyPopupTitle,
        visible: false,
        modal: true,
        iframe: true,
        close: function () {
            $("body").css("overflow", "");
        },
        deactivate: function () {
            this.destroy();
        },
        content: baseUrl + "/CopyForm?formtype=" + FORMTYPEID + "&mode=data"
    }).data("kendoWindow").center().open();
}

function loadCopyData(dataToCopy, showMatrixAttachmentNotification) {
    if (dataToCopy != "") {
        loadData({
            isCopy: true,
            data: leanformsNext.loadXml(dataToCopy)
        });
    }

    $("#copydialog").data("kendoWindow").close();
    core.notify("success", resources.copySuccessMessage);

    if (showMatrixAttachmentNotification) {
        core.notify("warn", resources.viewForm.matrixAttachmentCopyWarning);
    }
}

/*
 * Lock
 */
function updateLock(release) {
    var action = release ? "release=true" : "extend=true";
    navigator.sendBeacon(baseUrl + "/api/forms/" + FORMID + "/lock?" + action);
}

function releaseLock() {
    updateLock(true);
}

/*
 * Required validation.
 */
function checkRequired() {
    let isValid = true;

    // Validate file inputs.
    let elements = document.querySelectorAll("input[required][type=file]");
    [...elements].forEach((element) => {
        if (core.isVisible(element)) {
            const attachmentsDivId = element.getAttribute("id").replace("id_", "attachments_");
            const attachmentDiv = document.querySelector(`#${attachmentsDivId}`);

            if (attachmentDiv.innerHTML) {
                validation.hideError(element);
            }
            else {
                isValid = validation.showError(element, resources.validationMessages.required);
            }
        }
    });

    // Validate inspection points.
    const controller = window.questionControllerRegistry?.get('inspectionpoint');

    if (controller) {
        elements = document.querySelectorAll('.inspection-point-add-container[required]');
        [...elements].forEach((element) => {
            if (core.isVisible(element)) {
                const hasInspectionData = controller?.validate(element);

                if (hasInspectionData) {
                    validation.hideError(element);
                }
                else {
                    isValid = validation.showError(element, resources.inspection.inspectionPointRequired);
                }
            }
        });
    }

    // Parse canvas.
    elements = document.querySelectorAll("textarea[required][iscanvas]");
    [...elements].forEach((element) => {
        if (!element.hasAttribute("disabled")) {
            try {
                var resetButton = element.parentNode.querySelector(".clear-drawing");
                var resetButtonIsVisible = core.isVisible(resetButton);
                var resetButtonIsEnabled = !resetButton.hasAttribute("disabled");

                if (resetButtonIsVisible && resetButtonIsEnabled && element.value.trim() === "") {
                    isValid = validation.showError(element, resources.validationMessages.required);
                }
                else {
                    validation.hideError(element);
                }
            }
            catch (e) { }
        }
    });

    // Parse matrix.
    elements = document.querySelectorAll("textarea[required][type=matrix]");
    [...elements].forEach((element) => {
        if (!element.hasAttribute("disabled")) {
            try {
                var container = element.closest(".matrix-div");
                var matrixIsVisible = core.isVisible(container);
                var matrixIsEnabled = core.isVisible(container.querySelector(".matrixAdd"));

                if (matrixIsVisible && matrixIsEnabled && element.value.indexOf("line id") < 0) {
                    isValid = validation.showError(element, resources.validationMessages.required);
                }
                else {
                    validation.hideError(element);
                }
            }
            catch (e) { }
        }
    });

    return isValid;
}


/**
 * Validates dataset usernames by checking them against the server.
 * @param {Function} callback - Callback function that receives a boolean indicating validity.
 * @returns {void}
 */
function checkDatasetUsername(callback) {
    var usernames = $(".is-dataset-username").map(function () {
        var val = $(this).val();

        if (val) {
            return val;
        }
    }).get();

    if (!usernames.length) {
        return callback(true);
    }

    $.ajax({
        url: baseUrl + "/api/users/check-usernames",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(usernames),
        success: function (invalidUsername) {
            var isValidUsername = !invalidUsername;

            if (!isValidUsername) {
                showUsernameDeclineDialog(invalidUsername);
            }

            callback(isValidUsername);
        },
        error: function (xhr) {
            if (xhr.readyState !== 0) {
                return leanformsNext.onAjaxError(xhr);
            }

            // Likely offline, let forward continue without checking.
            callback(true);
        }
    });
}

/**
 * Shows a dialog when a username validation fails.
 * @param {string} username - The invalid username to display.
 * @returns {void}
 */
function showUsernameDeclineDialog(username) {
    $('#windowcontainer').append('<div id="usernamedecline-dialog"></div>');

    var usernameDeclinedWindow = $("#usernamedecline-dialog").kendoWindow({
        title: resources.datasetUsernameTexts.title,
        width: coreUI.getPopupWidth(500),
        visible: false,
        modal: true,
        resizable: false,
        draggable: false,
        deactivate: function () {
            this.destroy();
        }
    }).data("kendoWindow");

    usernameDeclinedWindow.content(
        "<div class=\"popup-page popup-size-auto\">" +
        "<div class=\"popup-content\">" +
        resources.datasetUsernameTexts.body.replace("{0}", core.htmlEncode(username)) +
        "</div>" +
        "<div class=\"popup-toolbar\">" +
        "  <button type=\"button\" id=\"btnOk\" class=\"button button-tall button-primary\"><span class=\"button-icon lf-icon-check\"></span><span>" + resources.datasetUsernameTexts.buttonLabel + "</span></button>" +
        "</div>" +
        "</div>"
    );

    $(usernameDeclinedWindow.element).find("#btnOk").on("click", function () {
        usernameDeclinedWindow.close();
    });

    usernameDeclinedWindow.center().open();
}

/*
 * Matrix.
 */
function resetMatrixHeader(e) {
    $(function () {
        setTimeout(function delayedResetMatrixHeader() {
            e.sender.thead.find("th").each(function (index) {
                var el = $(this);

                if (el.hasClass("matrix-hidden-column") || el.hasClass("rights-hidden-column")) {
                    e.sender.hideColumn(index);
                }
            });
        }, 0);
    });
}

// Kendo's Draggable (used by Resizable and Sortable) calls preventDefault() on
// pointerdown/mousedown which blocks all native touch scrolling. Suppress it for touch
// interactions so the browser can handle scrolling, but preserve it for the drag indicator.
function enableMatrixTouchScroll(matrixGrid) {
    var content = matrixGrid.wrapper.closest('.matrix-div').find('.k-grid-content')[0];

    if (!content) {
        return;
    }

    var isTouchInteraction = false;

    function suppress(e) {
        if (e.type === 'touchstart') {
            isTouchInteraction = true;
        } else if (e.type === 'pointerdown') {
            isTouchInteraction = e.pointerType === 'touch';
        }

        if (isTouchInteraction && !e.target.closest('.drag-indicator')) {
            e.preventDefault = function () { };
        }

        if (e.type === 'mousedown') {
            isTouchInteraction = false;
        }
    }

    content.addEventListener('pointerdown', suppress, { capture: true });
    content.addEventListener('touchstart', suppress, { capture: true });
    content.addEventListener('mousedown', suppress, { capture: true });
}

function handleMatrixSelect(e) {
    var selected = this.select();
    var rowNumber = selected.children().first().text();
    var isTotal = !new RegExp("\\d+").test(rowNumber);

    if (isTotal) {
        selected.removeClass("k-selected");
    }
}

function toggleMatrix(link, tableId, showText, hideText) {
    var $link = $(link);
    var isAllVisible = $link.data("showing-all");

    var table = $("#" + tableId);
    var matrixGrid = table.data("kendoGrid");
    var headerTable = table.closest(".matrix-div").find(".k-grid-header-table");

    headerTable.find(isAllVisible ? ".matrix-visible-column" : ".matrix-hidden-column").each(function () {
        var $headerCell = $(this);
        var index = $headerCell.index();

        if (isAllVisible) {
            matrixGrid.hideColumn(index);
        } else {
            matrixGrid.showColumn(index);
        }

        $headerCell.toggleClass("matrix-visible-column matrix-hidden-column");
    });

    $link
        .text(isAllVisible ? showText : hideText)
        .data("showing-all", !isAllVisible);
}

function initMatrixPopup(container) {
    container.append("<iframe id=\"iMatrixForm\" scrolling=\"auto\" frameborder=\"0\" src=\"\"></iframe>");

    container.kendoWindow({
        visible: false,
        height: coreUI.getPopupHeight(900),
        width: coreUI.getPopupWidth(940),
        title: "Matrix",
        modal: true,
        close: function () {
            $("body").css("overflow", "");
        },
        deactivate: function () {
            $("#iMatrixForm").attr("src", "about:blank");
        }
    });
};

function openMatrixPopup(questionId, matrixFormTypeId, mode) {
    var dataInputId = "md_" + questionId;
    var dataInput = $("#" + dataInputId);

    var canEdit = mode === "new" || dataInput.parent().find(".matrixEdit").is(":visible");
    var selected = $("#id_" + questionId + " tr.k-selected").index();
    var indexParam = "index=" + (mode === "edit" && typeof selected === "number" ? selected : -1);

    var params = [
        "FormTypeId=" + matrixFormTypeId,

        // ParentFormTypeId is used only by service worker.
        "ParentFormTypeId=" + BASEID,

        // can-edit-question is used by server and service worker.
        "can-edit-question=" + canEdit,

        // Prevents signing in as guest when it shouldn't happen.
        "was-logged-in=" + !isGuest,

        // Also used by server to determine that this is a matrix.
        "parent-question=" + questionId,
        indexParam
    ];

    if (mode !== "new" && selected > -1) {
        var matrix = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
        var lines = $(matrix).find("line");

        params.push("lineid=" + lines.eq(selected).attr("id"));
    }

    if (FORMGUID !== "00000000-0000-0000-0000-000000000000") {
        params.push("parent-guid=" + FORMGUID);
    }

    var matrixDiv = $("#matrixDiv");

    if (!matrixDiv.data("kendoWindow")) {
        initMatrixPopup(matrixDiv);
    }

    // Needs to be after initMatrixPopup.
    var link = baseUrl + "/ViewForm?" + params.join("&");
    $("#iMatrixForm").attr("src", link);

    // Avoid scrolling outer body when popup is open.
    $("body").css("overflow", "hidden");

    var popup = matrixDiv.data("kendoWindow");
    popup.setOptions({
        height: coreUI.getPopupHeight(860)
    });
    popup.center().open();
}

function getDisplayValue(questionId, value) {
    var questionEl = document.getElementById("id_" + questionId);
    var isRadioButton = false;

    if (!questionEl) {
        questionEl = document.getElementById("id_" + questionId + "_" + value);
        isRadioButton = true;
    }

    if (!questionEl) {
        return {
            value: value
        };
    }

    if (isRadioButton) {
        var radioLabelId = questionEl.getAttribute("aria-labelledby");
        var radioLabel = document.getElementById(radioLabelId);

        return {
            value: radioLabel.textContent
        };
    }

    var tagName = questionEl.tagName.toLowerCase();
    var type = questionEl.type;

    if (tagName === "select") {
        var selectedOption = $(questionEl).find(":selected");
        var listId = selectedOption.data("list");

        return {
            value: selectedOption.text(),
            listId: listId
        };
    }

    if (tagName === "input" && type === "checkbox") {
        var checkboxLabelId = questionEl.getAttribute("aria-labelledby");
        if (!checkboxLabelId) {
            return {
                value: "[X]"
            };
        }

        var checkboxLabel = document.getElementById(checkboxLabelId);

        return {
            value: checkboxLabel.textContent
        };
    }

    return {
        value: value
    };
}

function getMatrixLineData() {
    var line = leanformsNext.loadXml("<line><linefields></linefields><attachments></attachments></line>");
    var lineFields = line.find("linefields");

    var formData = $(".main-form").serializeArray();

    // Id's are numerical. Checkbox id's are followed by # and another number (or -1).
    var questionIdRegex = /^(?:ds_)?[0-9]+(?:#-?[0-9]+)?$/;

    formData
        .filter(function (question) {
            return questionIdRegex.test(question.name);
        })
        .forEach(function (question) {
            var questionId = question.name;
            var value = question.value;
            var questionData = getDisplayValue(questionId, value);

            // Create element this way to avoid jQuery adding namespace attribute, which breaks some server side parsing.
            var field = $(document.createElementNS(null, "field"));
            field.attr("vraagid", questionId);
            field.attr("value", value);
            field.attr("display", questionData.value);

            if (questionData.listId) {
                field.attr("list", questionData.listId);
            }

            lineFields.append(field);
        });

    return line.find("line");
}

function getMatrixLineAttachments() {
    var attachments = [];

    $(".attachment-container").each(function () {
        var file = $(this);

        var state = file.data("state");
        var rawFile = file.data("file");
        var needsDrawingUpdate = file.data("needsDrawingUpdate");
        var offlineId = file.data("offline-id");
        var guid = file.data("guid");
        var fileName = file.data("filename");
        var step = file.data("step");
        var isDatasetValue = file.data("isDatasetValue");
        var isCopy = file.data("isCopy");
        var datasetField = file.data("datasetField");
        var questionId = file.data("question");
        var displayName = file.find(".attachment-text").text();

        attachments.push({
            type: "file",
            state: state,
            data: rawFile,
            needsDrawingUpdate: needsDrawingUpdate,
            offlineId: offlineId,
            guid: guid,
            fileName: fileName,
            step: step,
            isDatasetValue: isDatasetValue,
            isCopy: isCopy,
            datasetField: datasetField,
            displayName: displayName,
            questionId: questionId
        });
    });

    $(".q-input .canvas-container").each(function () {
        var container = $(this);
        var canvas = container.find(".lower-canvas");

        var questionId = canvas.attr("id").substring(2);
        var state = canvas.data("state");
        var offlineId = canvas.data("offline-id");
        var guid = canvas.data("guid");
        var fileName = canvas.data("filename");
        var datasetField = null;
        var drawingData = changedDrawings[questionId];

        if (state !== "saved" && !drawingData && typeof offlineId === "undefined") {
            return;
        }

        var datasetValue = $("#file_" + questionId).val();
        if (datasetValue && datasetValue != "") {
            var json = JSON.parse(datasetValue);
            fileName = json.fileName;
            datasetField = json.datasetField;
        }

        attachments.push({
            type: "drawing",
            state: state,
            data: drawingData,
            offlineId: offlineId,
            guid: guid,
            fileName: fileName,
            questionId: questionId,
            datasetField: datasetField
        });
    });

    return attachments;
}

function setMatrixXMLToInput(input, jqXML) {
    input.val(jqXML.find("matrix").html());
}

function removeMatrixLine(questionId) {
    var dataInputId = "md_" + questionId;
    var dataInput = $("#" + dataInputId);
    var matrix = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
    var index = parseInt($("#id_" + questionId + " .k-selected td:first").html()) - 1;
    var line = matrix.find("line")[index];
    var lineLocalAttachments = [];
    var lineId = +$(line).attr("id");
    var lineActions = getMatrixLineActions(questionId, lineId);

    if (lineActions && lineActions.length > 0) {
        formControls.showConfirmDialog(resources.confirmRemoveMatrixAction, function () {
            lineActions.forEach(function (action) {
                if (action.oid !== -1) {
                    $.ajax({
                        url: baseUrl + "/api/actions/" + action.oid,
                        method: "DELETE",
                        success: function () { },
                        error: leanformsNext.onAjaxError
                    });
                }

                $("#grdActions").data("kendoGrid").dataSource.remove(action);
                $("#grdActions").data("kendoGrid").refresh();
            });

            removeMatrixLine(questionId);
        });

        return;
    }

    try {
        customRemoveMatrixLine(line, baseUrl);
    }
    catch (e) { }

    if (matrixAttachments.hasOwnProperty(questionId)) {
        lineLocalAttachments = matrixAttachments[questionId][lineId];
        delete matrixAttachments[questionId][lineId];
    }

    $(line).remove();

    setMatrixXMLToInput(dataInput, matrix);
    redrawMatrix(dataInputId);

    closeMatrixUndo();

    var content = `
        ${resources.matrix.lineDeletedText}&nbsp;&nbsp;&nbsp;
        <button type="button" class="button matrix-undo-button">
            <span>${resources.matrix.lineUndoButtonText}</span>
        </button>`;
    var notification = core.notify("warn", content, { duration: 12 * 1000 });
    notification.querySelector(".matrix-undo-button").addEventListener("click", restoreMatrixLine, false);

    matrixUndo = {
        notification: notification,
        questionId: questionId,
        index: index,
        line: line,
        localAttachments: lineLocalAttachments
    };
}

function closeMatrixUndo() {
    if (matrixUndo && matrixUndo.notification) {
        core.hideNotification(matrixUndo.notification);
        matrixUndo = null;
    }
}

function restoreMatrixLine() {
    if (!matrixUndo) {
        return;
    }

    core.hideNotification(matrixUndo.notification);

    var questionId = matrixUndo.questionId;
    var index = matrixUndo.index;
    var line = $(matrixUndo.line);
    var localAttachments = matrixUndo.localAttachments;

    var lineId = +line.attr("id");

    if (matrixAttachments.hasOwnProperty(questionId)) {
        matrixAttachments[questionId][lineId] = localAttachments;
    }

    var dataInputId = "md_" + questionId;
    var dataInput = $("#" + dataInputId);
    var matrix = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
    var lines = matrix.find("line");

    if (index === 0) {
        line.prependTo(matrix.find("matrix"));
    }
    else {
        line.insertAfter(lines.eq(index - 1));
    }

    setMatrixXMLToInput(dataInput, matrix);
    redrawMatrix(dataInputId);
    matrixUndo = null;
}

/**
 * Duplicates the last line in the matrix.
 */
function duplicateMatrixLine() {
    const matrixDiv = this.closest(".matrix-div");
    const dataInput = $(matrixDiv).find("textarea[type=matrix]");
    const dataInputId = dataInput.attr("id");
    const matrix = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
    const lines = matrix.find("line");
    const line = lines.last();

    const newLine = line.clone();
    newLine.attr("id", getNextLineId(matrix));
    newLine.children("attachments").empty();

    // Remove every question data that has attribute 'data-donot-copy' in its header.
    const doNotCopyHeaders = matrixDiv.querySelectorAll("th[data-donot-copy]");
    doNotCopyHeaders.forEach((header) => {
        const fieldId = header.getAttribute("fldid");

        // Remove from newline.
        newLine.find("field[vraagid=" + fieldId + "]").remove();
    });

    line.after(newLine);

    setMatrixXMLToInput(dataInput, matrix);
    redrawMatrix(dataInputId);
}

function renewMatrixDialog() {
    var newUrl = $("#iMatrixForm").attr("src")
        .replace(/&index=\d+/, "&index=-1")
        .replace(/&lineid=\d*/, "&lineid=");

    $("#iMatrixForm").attr("src", newUrl);
}

// This is called inside the matrix iframe.
function saveMatrixLine(keepOpen) {
    toggleSaveButtons(false);

    if (isDataCorrector || validation.validateForm({ container: document, scrollOffset: 100, customValidation: checkRequired })) {
        toggleLoadingOverlay(true);

        // TODO: This was only at save, not at save new.
        $("[disabled]:not(button)").removeAttr("disabled");

        var lineData = getMatrixLineData();
        var attachments = getMatrixLineAttachments();

        var index = window.location.href.match(/&index=(-?\d+)/)[1];
        var parentQuestionId = window.location.href.match(/&parent-question=(\d+)/)[1];

        parent.handleMatrixSave(keepOpen, lineData, attachments, index, parentQuestionId);
    }
    else {
        toggleSaveButtons(true);
    }
}

function toggleLoadingOverlay(state) {
    typeof application !== "undefined" ? application.lockScreen(state) : kendo.ui.progress($(document.body), state);
}

function getNextLineId(matrix) {
    var idElement = matrix.find('id');
    if (!idElement.length) {
        // TODO: IE is no longer supported - can this be simplified? 'Creating with parseXML is required for IE'.
        idElement = $($.parseXML("<id value=\"1\" />")).find("id");
        matrix.find("matrix").prepend(idElement);
    }

    var nextId = +idElement.attr("value");
    idElement.attr("value", nextId + 1);

    return nextId;
}

function addMatrixLineXml(lineData, index, dataInput) {
    var matrix = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
    matrix.find("matrix").append(lineData);

    var lines = matrix.find("line");
    var newLine = lines.eq(lines.length - 1);
    var id;

    if (index === "-1") {
        id = getNextLineId(matrix);
    }
    else {
        var oldLine = lines.eq(index);
        id = oldLine.attr("id");
        oldLine.replaceWith(newLine);
    }

    newLine.attr("id", id);
    setMatrixXMLToInput(dataInput, matrix);

    return +id;
}

function resetDatasetLinkbuttons() {
    $(".dataset").each(function () {
        $("#btn_" + this.getAttribute("name")).hide();
    });
}

// This is called from the matrix popup.
function handleMatrixSave(keepOpen, lineData, attachments, index, parentQuestionId) {
    closeMatrixUndo();

    var dataInputId = "md_" + parentQuestionId;
    var dataInput = $("#" + dataInputId);
    var questionId = +dataInput.attr("name");

    var lineId = addMatrixLineXml(lineData, index, dataInput);
    if (!matrixAttachments.hasOwnProperty(questionId)) {
        matrixAttachments[questionId] = {};
    }

    matrixAttachments[questionId][lineId] = attachments;
    if (keepOpen) {
        renewMatrixDialog();
    }
    else {
        $("#matrixDiv").data("kendoWindow").close();
    }

    redrawMatrix(dataInputId);
    addMatrixActions(lineId);

    toggleLoadingOverlay(false);

    // We have added a line so we can remove any validation errors (for now).
    validation.hideError(dataInput?.get(0));
}

function addMatrixActions(lineId) {
    initActionsGrid();

    const actionGrid = $("#grdActions").data("kendoGrid");
    matrixActions.forEach((action) => {
        // Kendo does not add the object to the datasource if not cloned!!
        const clonedAction = $.extend({}, action);

        clonedAction.lineId = lineId;
        clonedAction.questionBase = clonedAction.questionNumber;
        clonedAction.questionNumber = getMatrixLineNumber(clonedAction);
        actionGrid.dataSource.add(clonedAction);
    });

    matrixActions = [];
}

/*
 * Saving
 */
function getMatrixAttachments(isOffline, attachments, fileData) {
    var attachmentData = [];
    var toUpload = [];
    var drawings = [];

    for (var matrixQuestionId in matrixAttachments) {
        var lines = matrixAttachments[matrixQuestionId];
        var linesData = [];

        for (var lineId in lines) {
            var lineAttachments = lines[lineId];
            var line = {
                id: lineId,
                attachments: []
            };

            lineAttachments.forEach(function (attachment) {
                var isNew = attachment.state !== "saved";
                var needsDrawingUpdate = attachment.needsDrawingUpdate;
                var questionId = attachment.questionId;
                var step = attachment.step;
                var isDatasetValue = attachment.isDatasetValue;
                var datasetField = attachment.datasetField;
                var fileName = attachment.fileName;
                var rawFile = attachment.data;
                var guid = attachment.guid;
                var displayName = attachment.displayName;
                var offlineId = attachment.offlineId;
                var toUploadData;

                if (attachment.type === "drawing") {
                    if (!isNew) {
                        line.attachments.push({
                            type: "drawing",
                            state: "saved",
                            fileName: fileName,
                            questionId: questionId,
                            isDatasetValue: isDatasetValue,
                            datasetField: datasetField
                        });
                    }
                    else {
                        if (!isOffline) {
                            drawings.push({
                                data: rawFile,
                                questionId: questionId,
                                matrixQuestionId: matrixQuestionId,
                                lineId: lineId
                            });
                        }

                        var data = {
                            type: "drawing",
                            questionId: questionId
                        };

                        if (isOffline) {
                            data.data = rawFile;
                            data.offlineId = offlineId;
                            data.metadata = {
                                isFromMatrix: true,
                                matrixQuestionId: matrixQuestionId,
                                lineId: lineId
                            };
                        }

                        line.attachments.push(data);
                    }

                    return;
                }

                if (isNew) {
                    if (isOffline) {
                        line.attachments.push({
                            type: "file",
                            data: rawFile,
                            displayName: displayName,
                            questionId: questionId,
                            offlineId: offlineId,
                            metadata: {
                                isFromMatrix: true,
                                matrixQuestionId: matrixQuestionId,
                                lineId: lineId
                            }
                        });
                    }
                    else if (guid) {
                        attachments[guid] = {
                            questionId: questionId,
                            displayName: displayName,
                            isFromMatrix: true,
                            matrixQuestionId: matrixQuestionId,
                            lineId: lineId
                        };

                        fileData[guid] = rawFile;

                        line.attachments.push({
                            guid: guid,
                            displayName: displayName,
                            questionId: questionId
                        });
                    }
                    else {
                        var localGuid = kendo.guid();
                        attachment.guid = localGuid;

                        line.attachments.push({
                            guid: localGuid,
                            displayName: displayName,
                            questionId: questionId
                        });

                        toUploadData = {
                            oldGuid: localGuid,
                            questionId: questionId,
                            displayName: displayName,
                            file: rawFile,
                            isFromMatrix: true,
                            matrixQuestionId: matrixQuestionId,
                            lineId: lineId
                        };
                    }
                }
                else {
                    line.attachments.push({
                        state: "saved",
                        step: step,
                        fileName: fileName,
                        displayName: displayName,
                        questionId: questionId,
                        isDatasetValue: isDatasetValue,
                        datasetField: datasetField
                    });

                    if (needsDrawingUpdate) {
                        var localGuid = kendo.guid();
                        attachment.guid = localGuid;

                        toUploadData = {
                            isImageDrawingUpdate: true,
                            oldGuid: localGuid,
                            questionId: questionId,
                            file: rawFile,
                            filename: fileName,
                            isFromMatrix: true,
                            matrixQuestionId: matrixQuestionId,
                            lineId: lineId
                        };
                    }
                }

                if (toUploadData) {
                    toUpload.push(toUploadData);
                }
            });

            if (lineAttachments.length) {
                linesData.push(line);
            }
        }

        if (linesData.length) {
            attachmentData.push({
                questionId: matrixQuestionId,
                lines: linesData
            });
        }
    }

    return {
        attachmentData: attachmentData,
        toUpload: toUpload,
        drawings: drawings
    };
}

function getUsedLists() {
    var listIds = [];

    $(".form-content select").each(function () {
        var selectedEl = $(this).find(":selected");
        var selectedList = selectedEl.data("list");

        if (selectedList) {
            listIds.push(this.id + "=" + selectedList);
        }
    });

    var lists = listIds.length > 0 ? "l_" + listIds.join(",l_") : "";

    return lists;
}

function sendForm(action, callback) {
    toggleLoadingOverlay(true);
    closeMatrixUndo();

    copyReadOnlyFields();

    const usedLists = getUsedLists();
    const listsParam = usedLists !== "" ? [{ name: "lists", value: usedLists }] : [];

    const actionsGrid = $("#grdActions").data("kendoGrid");
    const actionsData = actionsGrid ? JSON.stringify(actionsGrid._data) || "" : "";
    const actionsParam = [{ name: "actions", value: actionsData }];

    const formFields = $(".main-form").serializeArray();
    const fullData = formFields.concat(listsParam, actionsParam);

    if (OFFLINEID !== -1) {
        saveFormOffline(action, fullData);
        return;
    }

    let attachments = {};
    let fileData = {};
    let toUpload = [];

    $(".attachment-container").each(function () {
        var file = $(this);
        var state = file.data("state");
        var needsDrawingUpdate = file.data("needsDrawingUpdate");

        if (state !== "new" && !needsDrawingUpdate) {
            return;
        }

        var guid = file.data("guid");
        var questionId = file.data("question");
        var rawFile = file.data("file");
        var filename = file.data("filename");
        var displayName = file.find(".attachment-text").text();

        var serverData = {
            questionId: questionId,
            displayName: displayName
        };

        if (guid && !needsDrawingUpdate) {
            attachments[guid] = serverData;
            fileData[guid] = rawFile;
        }
        else {
            var localGuid = kendo.guid();
            file.data("guid", localGuid);

            serverData.oldGuid = localGuid;
            serverData.file = rawFile;

            if (needsDrawingUpdate) {
                serverData.isImageDrawingUpdate = true;
                serverData.filename = filename;
            }

            toUpload.push(serverData);
        }
    });

    // Mutates attachments variable.
    var fullMatrixAttachmentData = getMatrixAttachments(false, attachments, fileData);
    var matrixAttachmentData = fullMatrixAttachmentData.attachmentData;
    var matrixDrawings = fullMatrixAttachmentData.drawings;
    toUpload = toUpload.concat(fullMatrixAttachmentData.toUpload);

    // Checks if uploaded attachments are still there.
    var formData = new FormData();
    formData.append("guids", JSON.stringify(Object.keys(attachments)));

    core.fetch({
        url: baseUrl + "/api/attachments/check",
        config: {
            body: formData,
            method: "POST"
        }
    })
        .then((response) => response.json())
        .then((response) => {
            var hasMissingFiles = Object.keys(toUpload).length;
            var hasChangedDrawings = Object.keys(changedDrawings).length;
            var isMissingAny = response.isMissingAny || hasMissingFiles || hasChangedDrawings || matrixDrawings.length;

            if (isMissingAny) {
                uploadMissingAttachments(attachments, fileData, matrixAttachmentData, matrixDrawings, response, toUpload, function (completeAttachments, completeMatrixAttachments) {
                    saveFormOnNetwork(fullData, completeAttachments, completeMatrixAttachments, action, callback);
                });
            }
            else {
                saveFormOnNetwork(fullData, attachments, matrixAttachmentData, action, callback);
            }
        }).catch((error) => {
            toggleSaveButtons(true);

            var hasBeenSavedOnline = FORMID !== "-1";

            if (hasBeenSavedOnline && !window.navigator.onLine) {
                resetFormSaveUI();
                return core.notify("warn", resources.hasBeenSavedOnline, { duration: 0 });
            }

            if (!core.supportsOffline()) {
                return handleFormSaveError(arguments, this);
            }

            saveFormOffline(action, fullData);
        });
}

function uploadMissingAttachments(attachments, fileData, matrixAttachmentData, matrixDrawings, response, toUpload, callback) {
    setProgress(0);

    var uploadRequests = [];
    var completedUploads = 0;

    if (response.isMissingAny) {
        response.missingGuids.forEach(function (guid) {
            var serverData = attachments[guid];
            serverData.oldGuid = guid;
            serverData.file = fileData[guid];

            toUpload.push(serverData);

            delete attachments[guid];
        });
    }

    toUpload.forEach(function (file) {
        var metadata = {};

        if (file.isFromMatrix) {
            metadata = {
                isFromMatrix: true,
                matrixQuestionId: file.matrixQuestionId,
                lineId: file.lineId
            };
        }

        if (file.isImageDrawingUpdate) {
            metadata.isImageDrawingUpdate = true;
            metadata.filename = file.filename;
        }

        metadata.oldGuid = file.oldGuid;
        metadata.displayName = file.displayName;

        var request = createUploadRequest(file.questionId, file.file, false, file.isImageDrawingUpdate, metadata);
        uploadRequests.push(request);
    });

    for (var questionId in changedDrawings) {
        var drawingData = changedDrawings[questionId];

        uploadRequests.push(createUploadRequest(questionId, drawingData, true));
    }

    matrixDrawings.forEach(function (drawing) {
        var questionId = drawing.questionId;
        var drawingData = drawing.data;
        var matrixData = {
            isFromMatrix: true,
            matrixQuestionId: drawing.matrixQuestionId,
            lineId: drawing.lineId
        };

        uploadRequests.push(createUploadRequest(questionId, drawingData, true, false, matrixData));
    });

    var totalUploads = uploadRequests.length;

    uploadRequests.forEach(function (upload) {
        upload.send();
    });

    function onUploadLoad() {
        if (this.status !== 200) {
            handleFormSaveError(this);

            uploadRequests.forEach(function (upload) {
                try {
                    upload.abort();
                }
                catch (err) {
                    console.error("Could not abort upload after error.", err);
                }
            });

            return;
        }

        var uploaded = JSON.parse(this.response);
        var metadata = uploaded.metadata || {};

        var newGuid = uploaded.guid;
        var oldGuid = metadata.oldGuid;
        var displayName = metadata.displayName;
        var isImageDrawingUpdate = metadata.isImageDrawingUpdate;
        var questionId = uploaded.questionId;
        var isDrawing = uploaded.type === "drawing";

        if (!isImageDrawingUpdate) {
            attachments[newGuid] = {
                questionId: questionId
            };
        }

        if (metadata.isFromMatrix) {
            var matrixQuestionId = metadata.matrixQuestionId;
            var lineId = metadata.lineId;

            if (isDrawing) {
                attachments[newGuid].isFromMatrix = true;

                matrixAttachments[matrixQuestionId][lineId]
                    .find(function (attachment) {
                        return +attachment.questionId === questionId;
                    })
                    .guid = newGuid;

                matrixAttachmentData
                    .find(function (matrix) {
                        return matrix.questionId === matrixQuestionId;
                    })
                    .lines
                    .find(function (line) {
                        return line.id === lineId;
                    })
                    .attachments
                    .find(function (attachment) {
                        return +attachment.questionId === questionId;
                    })
                    .guid = newGuid;
            }
            else {
                if (!isImageDrawingUpdate) {
                    var attachment = attachments[newGuid];
                    attachment.isFromMatrix = true;
                    attachment.displayName = displayName;
                }

                var matrixAttachment = matrixAttachments[matrixQuestionId][lineId]
                    .find(function (attachment) {
                        return attachment.guid === oldGuid;
                    });

                var matrixAttachmentDataItem = matrixAttachmentData
                    .find(function (matrix) {
                        return matrix.questionId === matrixQuestionId;
                    })
                    .lines
                    .find(function (line) {
                        return line.id === lineId;
                    })
                    .attachments
                    .find(function (attachment) {
                        return attachment.guid === oldGuid;
                    });

                if (isImageDrawingUpdate) {
                    matrixAttachment.guid = undefined;
                    matrixAttachment.needsDrawingUpdate = undefined;
                    matrixAttachment.fileName = uploaded.filename;

                    matrixAttachmentDataItem.fileName = uploaded.filename;
                }
                else {
                    matrixAttachment.guid = newGuid;
                    matrixAttachmentDataItem.guid = newGuid;
                }
            }
        }
        else if (!isDrawing) {
            $("#attachments_" + questionId + " .attachment-container").each(function () {
                var preview = $(this);

                if (preview.data("guid") === oldGuid) {
                    if (isImageDrawingUpdate) {
                        preview
                            .removeData("guid")
                            .removeData("isDrawingUpdate")
                            .data("filename", uploaded.filename);

                        var link = preview.find("a");
                        var displayName = preview.find(".attachment-text").text();
                        var newUrl = baseUrl + uploaded.url + "&displayName=" + encodeURIComponent(displayName);

                        link.attr("href", newUrl);
                    }
                    else {
                        preview.data("guid", newGuid);
                    }

                    // Stops loop.
                    return false;
                }
            });

            if (!isImageDrawingUpdate) {
                attachments[newGuid].displayName = displayName;
            }
        }

        completedUploads++;

        setProgress(Math.round((completedUploads / totalUploads) * 100));

        if (completedUploads === totalUploads) {
            callback(attachments, matrixAttachmentData);
        }
    }

    function createUploadRequest(questionId, fileData, isDrawing, isImageDrawingUpdate, metadata) {
        var uploadXHR = new XMLHttpRequest();

        uploadXHR.addEventListener("load", onUploadLoad, false);
        uploadXHR.addEventListener("error", handleFormSaveError, false);

        var uploadUrl = baseUrl + "/api/attachments/" + questionId;
        var method = "POST";

        var attachmentFormData = new FormData();
        attachmentFormData.append("data", fileData);
        attachmentFormData.append("metadata", JSON.stringify(metadata));

        if (isDrawing) {
            uploadUrl += "?drawing=true";
        }

        if (isImageDrawingUpdate) {
            method = "PUT";

            attachmentFormData.append("filename", metadata.filename);
            attachmentFormData.append("formId", FORMID);
        }

        uploadXHR.open(method, uploadUrl, true);

        return {
            abort: uploadXHR.abort.bind(window),
            send: function () {
                uploadXHR.send(attachmentFormData);
            }
        };
    }
}

function saveFormOnNetwork(fullData, attachments, matrixAttachmentData, action, callback) {
    var attachmentsParam = [{ name: "attachments", value: JSON.stringify(attachments) }];
    var matrixAttachmentsParam = [{ name: "matrix-attachments", value: JSON.stringify(matrixAttachmentData) }];

    // Get inspection N/A state, only when editable.
    // This is done manually because otherwise unchecked checkboxes are never serialized.
    var inspectionsApplicableState = $(".inspection-not-applicable:enabled").map(function () {
        return {
            name: this.id,
            value: this.checked
        };
    }).get();

    fullData = fullData.concat(attachmentsParam, matrixAttachmentsParam, inspectionsApplicableState);
    var fullStringData = $.param(fullData);

    var isNew = FORMID === "-1";
    var url = baseUrl + "/api/forms" + (isNew ? "" : "/" + FORMID) + (action === "forward" ? "/forward" : "") + (isNew ? "?formTypeId=" + FORMTYPEID : "");

    $.ajax({
        url: url,
        type: isNew ? "POST" : "PUT",
        dataType: "json",
        data: fullStringData,
        error: handleFormSaveError,
        success: async function (data) {
            var savedId = data.oid;
            var oldFormId = FORMID;
            FORMID = savedId;
            FORMGUID = data.guid;

            showExportButtons();
            toggleLoadingOverlay(false);

            if (action === "forward") {
                // Dispatch event for custom scripts / plugins.
                const cancelled = !document.dispatchEvent(new CustomEvent("form-forwarded", {
                    cancelable: true,
                    detail: {
                        formTypeBaseId: BASEID,
                        formTypeId: FORMTYPEID,
                        formId: FORMID,
                        formGuid: FORMGUID,
                        isGuest: isGuest
                    }
                }));

                if (cancelled) {
                    return;
                }

                var restartParam = restartId > 0 ? "&restart-id=" + restartId : "";
                var confirmUrl = "/Confirm?formId=" + savedId + restartParam;

                // If we are within the application frame (logged in user) the application class exists.
                if (typeof application !== "undefined") {
                    application.setIframeUrl(confirmUrl);
                }
                else {
                    location.href = baseUrl + confirmUrl;
                }

                return;
            }

            $(".attachment-container").each(function () {
                var attachmentPreview = $(this);
                var state = attachmentPreview.data("state");

                if (state === "saved") {
                    return;
                }

                var questionId = attachmentPreview.data("question");
                var guid = attachmentPreview.data("guid");
                var link = attachmentPreview.find("a");
                var displayName = attachmentPreview.find(".attachment-text").text();

                var fileName = FORMID + "_" + questionId + "_" + guid;
                var newUrl = baseUrl + "/api/attachments?fileName=" + encodeURIComponent(fileName) + "&displayName=" + encodeURIComponent(displayName);

                link.attr("href", newUrl);
                attachmentPreview.data("filename", fileName);
                attachmentPreview.data("state", "saved");
            });

            var updatedMatrices = [];

            for (var matrixQuestionId in matrixAttachments) {
                var lines = matrixAttachments[matrixQuestionId];

                for (var lineId in lines) {
                    lines[lineId].forEach(function (attachment) {
                        if (attachment.guid) {
                            attachment.fileName = FORMID + "_" + attachment.questionId + "_" + attachment.guid;
                        }

                        if (attachment.guid && attachment.state !== "saved" && !updatedMatrices.includes(matrixQuestionId)) {
                            updatedMatrices.push(matrixQuestionId);
                        }

                        attachment.state = "saved";
                    });
                }
            }

            // Update matrix attachment links.
            updatedMatrices.forEach(updatedMatrixId => {
                redrawMatrix(`md_${updatedMatrixId}`);
            });

            // Update form ID on all controllers and notify them after form save.
            window.questionControllerRegistry.setFormId(savedId);
            await window.questionControllerRegistry.notifyControllersAfterFormSave(oldFormId, savedId, data);

            $("input[name^='file_']").val("");

            Object.keys(changedDrawings).forEach(function (drawingId) {
                $("#btn_" + drawingId).hide();

                var canvas = $("#C_" + drawingId).get(0).fabric;

                canvas.isDrawingMode = false;
                canvas.hoverCursor = "default";
                canvas.forEachObject(function (fabricObject) {
                    fabricObject.set("selectable", false);
                });

                $("#file_" + drawingId).val("");
            });

            changedDrawings = {};

            core.notify("success", resources.saveSuccessMessage);

            setProgress("hide");
            toggleSaveButtons(true);

            initActionsGrid({ id: savedId });

            var codeDisplayEl = $("#code-display");
            var currentCode = codeDisplayEl.text();

            if (currentCode !== data.code) {
                codeDisplayEl.text(data.code);
                codeDisplayEl.parent().addClass("code-changed");
            }

            callback && callback();
        }
    });
}

async function loadReportMatrices() {
    const reportMatrixInputs = $(".report-matrix textarea.matrix-data");

    if (reportMatrixInputs.length === 0) {
        return;
    }

    const isNew = FORMID === "-1";

    const parameter = isNew
        ? `formTypeId=${FORMTYPEID}`
        : `formId=${FORMID}`;

    const url = `${baseUrl}/api/forms/report-matrices?${parameter}`;
    const formDataResult = await core.fetch({ url: url });
    const formDataText = await formDataResult.text();
    const formDataXml = new window.DOMParser().parseFromString(formDataText, "text/xml");
    const $formDataXml = $(formDataXml);

    reportMatrixInputs.each(function () {
        const questionId = this.id.replace("md_", "");
        const field = $formDataXml.find(`field[vraagid="${questionId}"]`).get(0);

        if (field) {
            this.value = field.getAttribute("value");
        }

        redrawMatrix(this.id);
    });
}

function saveFormOffline(action, fullData) {
    var attachmentPromises = [];
    var previewElements = [];
    var offlineAttachments = [];

    $(".attachment-container").each(function () {
        var file = $(this);

        var isDatasetValue = file.data("isDatasetValue");
        var isCopy = file.data("isCopy");
        var offlineId = file.data("offline-id");

        if (isDatasetValue || isCopy) {
            // We will not have the file available in this case.
            // File is copied server-side through JSON in hidden file_ input.
            return;
        }

        if (typeof offlineId !== "undefined") {
            offlineAttachments.push(offlineId);
            return;
        }

        var questionId = file.data("question");
        var rawFile = file.data("file");
        var displayName = file.find(".attachment-text").text();

        var data = {
            type: "file",
            data: rawFile,
            displayName: displayName,
            questionId: questionId
        };

        var dbPromise = db.attachments.add(data);
        attachmentPromises.push(dbPromise);
        previewElements.push(file);
    });

    var changedDrawingElements = [];

    $(".q-input .canvas-container").each(function () {
        var container = $(this);
        var canvas = container.find(".lower-canvas");

        var offlineId = canvas.data("offline-id");
        var hasOfflineId = typeof offlineId !== "undefined";
        var questionId = canvas.attr("id").substring(2);

        if (changedDrawings.hasOwnProperty(questionId)) {
            var drawingData = changedDrawings[questionId];
            var data = {
                type: "drawing",
                data: drawingData,
                questionId: questionId
            };

            var dbPromise;
            if (hasOfflineId) {
                data.id = offlineId;
                dbPromise = indexedDatabase.attachments.put(data);
            }
            else {
                dbPromise = indexedDatabase.attachments.add(data);
            }

            attachmentPromises.push(dbPromise);
            changedDrawingElements.push(canvas);
        }
        else if (hasOfflineId) {
            offlineAttachments.push(offlineId);
        }
    });

    var fullMatrixAttachmentData = getMatrixAttachments(true);
    var matrixAttachmentData = fullMatrixAttachmentData.attachmentData;

    var flatMatrixAttachments = matrixAttachmentData
        .reduce(function (accu, matrix) {
            var lines = matrix.lines.reduce(function (accu, line) {
                return accu.concat(line.attachments);
            }, []);

            return accu.concat(lines);
        }, [])
        .filter(function (attachment) {
            var hasOfflineId = typeof attachment.offlineId !== "undefined";
            if (hasOfflineId && (attachment.type !== "drawing" || !attachment.data)) {
                offlineAttachments.push(attachment.offlineId);
                return false;
            }

            return true;
        });

    flatMatrixAttachments.forEach(function (attachment) {
        var hasOfflineId = typeof attachment.offlineId !== "undefined";

        if (attachment.type === "drawing" && hasOfflineId) {
            attachment.id = +attachment.offlineId;
            delete attachment.offlineId;

            var updatePromise = indexedDatabase.attachments.put(attachment);
            attachmentPromises.push(updatePromise);

            return;
        }

        delete attachment.offlineId;

        var dbPromise = indexedDatabase.attachments.add(attachment);
        attachmentPromises.push(dbPromise);
    });

    Promise.all(attachmentPromises)
        .then(function (attachmentIds) {
            var filesAmount = previewElements.length;
            var drawingsAmount = changedDrawingElements.length;
            var drawingsIndex = filesAmount + drawingsAmount;

            var fileIds = attachmentIds.slice(0, filesAmount);
            var drawingIds = attachmentIds.slice(filesAmount, drawingsIndex);
            var matrixIds = attachmentIds.slice(drawingsIndex);

            fileIds.forEach(function (id, index) {
                previewElements[index].data("offline-id", id);
            });

            drawingIds.forEach(function (id, index) {
                changedDrawingElements[index].data("offline-id", id);
            });

            matrixIds.forEach(function (id, index) {
                var attachment = flatMatrixAttachments[index];

                attachment.offlineId = id;
                delete attachment.data;
                delete attachment.metadata;
            });

            var formTitle = document.querySelector(".page-title").textContent;
            var offlineData = {
                userId: USERID,
                action: action,
                formTypeId: FORMTYPEID,
                baseId: BASEID,
                data: fullData,
                attachments: offlineAttachments.concat(attachmentIds),
                matrixAttachments: matrixAttachmentData,
                createdAt: Date.now(),
                title: formTitle
            };

            return indexedDatabase.transaction("rw", indexedDatabase.forms, function () {
                if (OFFLINEID !== -1) {
                    indexedDatabase.forms.update(OFFLINEID, offlineData);
                }
                else {
                    return indexedDatabase.forms.add(offlineData);
                }
            });
        })
        .then(function (returnValue) {
            if (window.navigator.onLine) {
                parent.syncOfflineData();
            }

            toggleLoadingOverlay(false);

            if (action === "forward" && typeof application !== "undefined") {
                var url = "/Confirm?offline=true&restart-id=" + BASEID;
                application.setIframeUrl(url);
            }
            else {
                if (OFFLINEID === -1) {
                    OFFLINEID = returnValue;
                }

                $(".attachment-container").data("offline-saved", true);

                changedDrawings = {};
                core.notify("info", resources.savedOfflineMessage);
                toggleSaveButtons(true);
            }
        })
        .catch(function (err) {
            handlePotentialQuotaError(err);
            handleFormSaveError(err);
        });
}

function handlePotentialQuotaError(err) {
    if (err.name === "QuotaExceededError" || (err.inner && err.inner.name === "QuotaExceededError")) {
        core.notify("error", resources.quotaErrorMessage);
        return true;
    }
}

function resetFormSaveUI() {
    toggleSaveButtons(true);
    toggleLoadingOverlay(false);
    setProgress("hide");
}

function handleFormSaveError() {
    resetFormSaveUI();
    leanformsNext.handleError(arguments);
}

function toggleSaveButtons(state) {
    $(".form-type-toolbar .button, #forwardFormFooter").prop("disabled", !state);
}

function saveForm(options) {
    options = options || {};

    // Disable buttons to prevent multiple clicks.
    toggleSaveButtons(false);

    if (options.forward) {
        // Offset is a position correction for the fixed form header (and some arbitrary extra).
        if (validation.validateForm({ container: document, scrollOffset: 150, customValidation: checkRequired })) {

            // Check for valid username.
            checkDatasetUsername((datasetUsernameValid) => {
                if (!datasetUsernameValid) {
                    toggleSaveButtons(true);
                    return;
                }

                sendForm("forward");
            });
        }
        else {
            // Not valid, enable buttons again.
            toggleSaveButtons(true);
        }
    }
    else {
        sendForm("save", options.callback);
    }
}

function exportForm() {
    toggleLoadingOverlay(true);
    core.downloadFile(`${baseUrl}/api/forms/export/${FORMID}`, $("form").serialize(), () => toggleLoadingOverlay(false), false);
}

function defaultFormExport() {
    toggleLoadingOverlay(true);
    core.downloadFile(`${baseUrl}/api/forms/${FORMID}/default-form-export`, $("form").serialize(), () => toggleLoadingOverlay(false), false);
}

function setProgress(percent) {
    if (percent === "hide") {
        document.body.style.setProperty("--form-progress-height", "0px");

        setTimeout(function () {
            document.body.style.setProperty("--form-progress-width", "0%");
        }, 250);
    }

    if (percent === 0) {
        document.body.style.setProperty("--form-progress-height", "5px");
    }

    document.body.style.setProperty("--form-progress-width", percent + "%");
}

/*
 * Actions
 */
var rowNumber = 0;
function resetRowNumber() {
    rowNumber = 0;
}

function renderNumber() {
    return rowNumber++;
}

function loadActions(options) {
    var id = options.id;
    var offlineData = options.offlineData;

    var config = {
        schema: {
            model: {
                id: "oid",
                fields: {
                    closedByName: { type: "string" },
                    description: { type: "string" },
                    initiatorId: { type: "number" },
                    initiatorName: { type: "string" },
                    oid: { type: "number" },
                    parentQuestionId: { type: "number" },
                    planDate: { type: "datetime" },
                    questionBase: { type: "string" },
                    questionId: { type: "number" },
                    questionNumber: { type: "string" },
                    remarks: { type: "string" },
                    selectedType: { type: "number" },
                    statusHtml: { type: "string" },
                    userId: { type: "number" },
                    username: { type: "string" },
                    informGroupAllowUser: { type: "boolean" },
                    informGroup: { type: "number" }
                }
            }
        }
    };

    if (id) {
        config.transport = {
            read: {
                dataType: "json",
                url: baseUrl + "/api/actions/form/" + id
            }
        }
    }

    var dataSource = new kendo.data.DataSource(config);

    if (offlineData) {
        // Setting the data directly causes unwanted properties to be added to the object.
        var data = JSON.parse(offlineData);

        data.forEach(function (action) {
            dataSource.add(action);
        });
    }

    return dataSource;
}

function initActionsGrid(options) {
    var id = options ? options.id : null;
    var grid = $("#grdActions").data("kendoGrid");

    if (grid) {
        if (id) {
            grid.setDataSource(loadActions(options));
            grid.refresh();
        }

        return;
    }

    $("#actions-container").html('<div id="grdActions"></div>');

    var isInit = true;

    $("#grdActions").kendoGrid({
        dataSource: options ? loadActions(options) : [],
        columns: [
            { field: "statusHtml", title: resources.actionGridTexts.state, width: 58, encoded: false },
            {
                field: "questionNumber",
                title: resources.actionGridTexts.number,
                width: 100,
                template: (dataItem) => {
                    return `<button type="button" onclick="editAction(${renderNumber()})" class="button">${getMatrixLineNumber(dataItem)}</button>`;
                },
            },
            { field: "description", title: resources.actionGridTexts.description },
            {
                field: "planDate",
                title: resources.actionGridTexts.planDate,
                width: 93,
                template: (dataItem) => {
                    return dating.formatDate(dataItem.planDate, formats.dateDisplayFormat);
                },
            },
            { field: "initiatorName", title: resources.actionGridTexts.initiator, width: 150 },
            { field: "username", title: resources.actionGridTexts.user, width: 150 },
            { field: "remarks", title: resources.actionGridTexts.remarks },
            {
                field: "closedDate",
                title: resources.actionGridTexts.closedDate,
                width: 108,
                template: (dataItem) => {
                    return dating.formatDate(dataItem.closedDate, formats.dateDisplayFormat);
                },
            },
            { field: "closedByName", title: resources.actionGridTexts.closedBy, width: 150 },
            { field: "oid", hidden: true }
        ],
        scrollable: false,
        dataBound: function () {
            resetRowNumber();

            if (isInit) {
                isInit = false;
                refreshActionGrid();
            }

            const hasActions = document.querySelector("#grdActions")?.querySelectorAll("tbody > tr").length > 0;
            $("#actions-container").toggleClass("hidden", !hasActions);
        }
    });
}

/**
 * Add a form action to the actions grid at the bottom of the page, the 'saveForm' method actually saves any then existing actions.
 * @param {FormData} formData               The form (fields) data.
 * @param {any} usersInGroup                The selected action owner (can be a user, group or an array of users).
 * @param {Integer} parentQuestionId        The referenced parent question.
 */
function saveAction(formData, usersInGroup, parentQuestionId) {
    let actionGrid = null;

    if (!isMatrix) {
        initActionsGrid();
        actionGrid = $("#grdActions").data("kendoGrid");
    }

    const isClosed = !!formData.get("closedAction");
    const informGroup = +formData.get("informGroup");
    const closedDate = formData.get("closedDate");
    const description = formData.get("description");
    const planDate = formData.get("planDate");
    const questionId = +formData.get("questionId");
    const questionNumber = formData.get("questionNumber");
    const remarks = formData.get("remarks");
    const selectedType = +formData.get("actionType");

    // We save the action per user.
    usersInGroup.forEach(async (selectedUser) => {
        if (selectedAction && !isMatrix) {
            // Modify existing action.
            selectedAction.description = description;
            selectedAction.planDate = dating.parseDateString(planDate, formats.dateDisplayFormat);
            selectedAction.informGroup = informGroup;

            // When the action is generated from 'User in group', we store the type as 'user'.
            selectedAction.selectedType = selectedType === 3 ? 1 : selectedType;
            selectedAction.userId = +selectedUser.userId;
            selectedAction.username = selectedUser.username;
            selectedAction.remarks = remarks;

            // Can be done, notsaved, overdue or planned.
            // overdue and planned are not set correctly after updating action.
            let stateClass = "notsaved";

            if (isClosed) {
                selectedAction.closedById = USERID;
                selectedAction.closedByName = USERNAME;
                selectedAction.closedDate = dating.parseDateString(closedDate, formats.dateDisplayFormat);

                stateClass = "done";
            }
            else if (selectedAction.oid === -1) {
                selectedAction.closedById = null;
                selectedAction.closedByName = null;
                selectedAction.closedDate = null;
            }

            let stateText = resources.actionGridTexts["state" + stateClass];

            if (stateClass !== "notsaved") {
                // Double parse to prevent XSS.
                stateText += " " + dating.formatDate(dating.parseDateString(closedDate, formats.dateDisplayFormat), formats.dateDisplayFormat);
            }

            selectedAction.statusHtml = `<span class="action-grid-state action-grid-state-${stateClass} with-tooltip"><tool-tip class="tooltip">${stateText}</tool-tip></span>`;

            actionGrid.refresh();

            if (selectedAction.oid !== -1) {
                var response = await core.fetch({
                    url: baseUrl + "/api/actions/" + selectedAction.oid,
                    config: {
                        body: formData,
                        method: "PUT"
                    }
                }).catch(leanformsNext.onAjaxError);

                if (!response?.ok) {
                    leanformsNext.onAjaxError(response);
                }
            }
        }
        else {
            // New action.
            var action = {
                description: description,
                initiatorId: USERID,
                initiatorName: USERNAME,
                oid: -1,
                parentQuestionId: parentQuestionId,
                planDate: dating.parseDateString(planDate, formats.dateDisplayFormat),
                questionId: questionId,
                questionNumber: questionNumber,
                selectedType: selectedType === 3 ? 1 : selectedType,
                statusHtml: `<span class="action-grid-state action-grid-state-notsaved with-tooltip"><tool-tip class="tooltip">${resources.actionGridTexts.statenotsaved}</tool-tip></span>`,
                userId: +selectedUser.userId,
                username: selectedUser.username,
                informGroup: informGroup
            };

            if (isMatrix) {
                parent.matrixActions.push(action);
            }
            else {
                actionGrid.dataSource.add(action);
            }
        }
    });
}

/**
 * Called by editAction and by the event on the form (action) button.
 * @param {Integer} questionId
 * @param {String} questionNumber
 * @param {Integer} parentQuestionId
 * @param {Integer} groupId
 * @param {Boolean} informGroupAllowUser
 * @param {Integer} informGroup
 * @param {Boolean} copyAnswer
 */
function showAction(questionId, questionNumber, parentQuestionId, groupId, informGroupAllowUser, informGroup, copyAnswer) {
    $("body").css("overflow", "hidden");
    $("#windowcontainer").append("<div id=\"dialog\"></div>");
    $("#dialog").kendoWindow({
        width: coreUI.getPopupWidth(1025),
        height: coreUI.getPopupHeight(710),
        title: resources.viewForm.action,
        visible: false,
        modal: true,
        iframe: true,
        deactivate: function () {
            this.destroy();
        },
        content: `${baseUrl}/Dialogs/ActionDialog?isFormAction=true&id=${selectedAction?.oid ?? -1}&isNewAction=${selectedAction === null}&questionId=${questionId}&questionNumber=${questionNumber}&parentQuestionId=${parentQuestionId}&groupId=${groupId}&informGroupAllowUser=${informGroupAllowUser}&informGroup=${informGroup}&copyAnswer=${copyAnswer}`,
        close: function () {
            $("body").css("overflow", "");
            // New selected action is set when a row in the actions grid is clicked.
            selectedAction = null;
        }
    }).data("kendoWindow").center().open();
}

function toggleActionButtons(state) {
    $("#action-popup .dialog-toolbar .button").prop("disabled", !state);
}

function closeActionDialog() {
    toggleActionButtons(false);
    $("#action-popup").data("kendoWindow").close();
}

function editAction(index) {
    var grd = $("#grdActions").data("kendoGrid");
    var selected = grd._data[index];
    selectedAction = selected;

    showAction(selected.questionId, selected.questionNumber, selected.parentQuestionId, null, selected.informGroupAllowUser, selected.informGroup);
}

function deleteAction() {
    $("#grdActions").data("kendoGrid").dataSource.remove(selectedAction);
    $("#grdActions").data("kendoGrid").refresh();
}

function getMatrixLineNumber(action) {
    var badge = "";

    if (!action.questionBase) {
        action.questionBase = action.questionNumber;
    }

    if (action.parentQuestionId) {
        var matrix = $("#id_" + action.parentQuestionId);
        var parentQuestionNumber = $('div[q="' + action.parentQuestionId + '"] .q-number').text().trim();
        var lineNumber = matrix.find('tr[data-lineid="' + action.lineId + '"] > td').eq(0).text().trim();
        var badgeTitle = resources.viewForm.badgeTitle.replace("{0}", parentQuestionNumber).replace("{1}", lineNumber);
        var lineText = lineNumber > 0 ? ' ' + resources.viewForm.matrixLineNumber + lineNumber : '';

        badge = '<span class="action-grid-matrix-badge" title="' + badgeTitle + '">' + parentQuestionNumber + lineText + '</span> ';
    }

    return badge + (action.questionBase ?? "");
}

function refreshActionGrid() {
    var actionsGrid = $("#grdActions").data("kendoGrid");
    if (!actionsGrid) {
        return;
    }

    actionsGrid.refresh();
}

function getMatrixLineActions(questionId, lineId) {
    var actionsGrid = $("#grdActions").data("kendoGrid");
    if (!actionsGrid) {
        return;
    }

    return actionsGrid._data.filter(action => action.parentQuestionId == questionId && action.lineId == lineId);
}

/*
 * Offline availability
 */
function toggleOfflineLabel(allowedOffline) {
    document.querySelector('#toggleOfflineButton').checked = allowedOffline;
}

function toggleOffline() {
    const toggleButton = document.querySelector("#toggleOfflineButton");

    if (toggleButton.checked) {
        installOffline();

        tryPersistIndexedDB();
    }
    else {
        // TODO: Hide while offline?
        removeOffline();
    }
}

function installOffline() {
    var cacheUrl = baseUrl + "/ViewForm?handler=OfflineForm&FormTypeId=" + BASEID;

    return core.fetch({ url: cacheUrl })
        .catch(leanformsNext.markNetworkError)
        .then(function (response) {
            return response.json();
        })
        .then(function (content) {
            // Previous promise step parses the response to an actual JSON object and provides it to the this step.
            return indexedDatabase.transaction("rw", indexedDatabase.formTypeUsers, indexedDatabase.formTypes, function () {
                indexedDatabase.formTypeUsers.add({
                    userId: USERID,
                    formTypeBaseId: content.baseId
                });

                indexedDatabase.formTypes.put({
                    baseId: content.baseId,
                    id: content.id,
                    lastChange: content.lastChange,
                    lists: content.lists,
                    html: content.html,
                    title: content.title,
                    init: content.init,
                    toolbar: content.toolbar,
                    warning: content.warning,
                    matrices: content.matrices
                });
            });
        })
        .then(function () {
            // TODO: wait for success before notifying?
            core.notify("success", resources.typeSavedOfflineMessage);
            parent.updateOfflineMenu();
        })
        .catch(function (err) {
            if (err.message === "lf-failed-fetch") {
                return core.notify("warn", resources.noNetworkMessage);
            }

            leanformsNext.handleError(err);
        });
}

function removeOffline() {
    indexedDatabase.transaction("rw", indexedDatabase.formTypeUsers, indexedDatabase.formTypes, function () {
        indexedDatabase.formTypeUsers.where({ userId: USERID, formTypeBaseId: +BASEID }).delete();
        indexedDatabase.formTypes.delete(+BASEID);
    })
        .then(function () {
            core.notify("info", resources.typeRemovedOfflineMessage);
            parent.updateOfflineMenu();
        }).catch(leanformsNext.handleError);
}

function tryPersistIndexedDB() {
    if (window.navigator.storage && window.navigator.storage.persist) {
        // May prompt user.
        // Chrome decides itself based on heuristics, may not ask user.
        window.navigator.storage.persist();
    }
}

/*
 * Handle change
 */
function handleOnChange(vanillaElement) {
    try {
        checkMessage(vanillaElement);

        // Remove id_, radio button id, checkbox id.
        var vanillaElementId = vanillaElement.id
            .substr(3)
            .split("_")[0]
            .split("#")[0];

        formControls.fillDependantList(vanillaElement, vanillaElementId);
        calc(vanillaElementId);

        // Do not check rights on first call (globalInit).
        if (!globalInit) {
            checkRights(vanillaElement);
        }

        changeDependentDate(vanillaElement);
        fillBarcodeValues(vanillaElement, vanillaElementId);

        // Validate.
        vanillaElement.dispatchEvent(new Event("validateonchange"));

        // On first call (globalInit) validate min/max (eventhandlers are not attached yet and only to be called on actual change - later).
        if (globalInit && vanillaElement.getAttribute("format") === "number") {
            validation.validateRangeState({ element: vanillaElement });
        }
    }
    catch (error) {
        console.error(vanillaElement, error);
        core.notify("error");
    }
}

/*
 * Handle key press
 */
function handleGs1OnKeyDown(vanillaElement, event) {
    // Ctrl + ]
    if (event.ctrlKey && event.key === "]") {
        var groupSeparator = String.fromCharCode(29);
        vanillaElement.value += groupSeparator;

        event.preventDefault();
    }

    // Enter
    if (event.key === "Enter") {
        var vanillaElementId = vanillaElement.id.substr(3);

        fillBarcodeValues(vanillaElement, vanillaElementId);
        goToNextBarcodeInput(vanillaElement);
    }
}

function hasHiddenParentElement(element) {
    let parentElement = element.parentElement;

    while (parentElement) {
        const isHidden = parentElement.type === "hidden" ||
            getComputedStyle(parentElement).display === "none" ||
            getComputedStyle(parentElement).visibility === "hidden" ||
            getComputedStyle(parentElement).opacity === "0" ||
            parentElement.closest("[style*='display: none']") !== null;

        if (isHidden) {
            return true;
        }

        parentElement = parentElement.parentElement;
    }

    return false;
}

function goToNextBarcodeInput(barcodeInput) {
    const currentContainer = barcodeInput.closest(".question-container");
    let next = currentContainer.nextElementSibling;

    if (!next) {
        const currentSection = currentContainer.closest(".form-part-container");
        let nextSection = currentSection.nextElementSibling;

        while (nextSection) {
            const firstContainer = nextSection.querySelector(".question-container");
            if (firstContainer) {
                next = firstContainer;
                break;
            }
            nextSection = nextSection.nextElementSibling;
        }
    }

    while (next) {
        const qInput = next.querySelector(".q-input");
        const input = next.querySelector("input, select, textarea");

        if (!qInput || !input) {
            next = next.nextElementSibling;
            continue;
        }

        if (parseInt(qInput.dataset.type) === formControls.questionTypes.barcode) {
            input.focus();
            return;
        }

        // ReadOnly attribute check is for selects because the prop check would be "undefined".
        const isReadOnly = input.readOnly || input.hasAttribute("readonly");
        const isDisabled = input.disabled;
        const isHidden = input.type === "hidden" ||
            getComputedStyle(input).display === "none" ||
            getComputedStyle(input).visibility === "hidden" ||
            getComputedStyle(input).opacity === "0" ||
            input.closest("[style*='display: none']") !== null ||
            hasHiddenParentElement(input);

        if (!isReadOnly && !isDisabled && !isHidden) {
            return;
        }

        if (!next.nextElementSibling) {
            const currentSection = next.closest(".form-part-container");
            let nextSection = currentSection?.nextElementSibling;

            while (nextSection) {
                const firstContainer = nextSection.querySelector(".question-container");

                if (firstContainer) {
                    next = firstContainer;
                    break;
                }

                nextSection = nextSection.nextElementSibling;
            }

            if (!nextSection) {
                break;
            }
        } else {
            next = next.nextElementSibling;
        }
    }
}

function fillBarcodeValues(vanillaElement, vanillaElementId) {
    if (!gs1Mappings || !gs1Mappings.hasOwnProperty(vanillaElementId)) {
        return;
    }

    var mapping = gs1Mappings[vanillaElementId];
    var barcode = vanillaElement.value;

    // Temporarily hide the '(' and ')' characters with Private Use Characters to prevent the library from conflicting with them.
    barcode = barcode.replace(/\(/g, '\uE000').replace(/\)/g, '\uE001');

    if (barcode.startsWith('http://') || barcode.startsWith('https://')) {
        cleanedBarcode = digitalLinkToGs1Barcode(barcode);
    } else {
        cleanedBarcode = replaceGs1Separators(barcode);
    }

    try {
        var parsedResult = window.gs1Parser.decode(cleanedBarcode);
        vanillaElement.setCustomValidity("");
    } catch (error) {
        vanillaElement.setCustomValidity(resources.validationMessages.invalidBarcode);
        validation.setErrorMessage(vanillaElement, resources.validationMessages.invalidBarcode);
        return;
    }

    if (!parsedResult) {
        return;
    }

    Object.keys(mapping).forEach(function (key) {
        var targetElement = document.getElementById("id_" + key);
        var applicationIdentifier = mapping[key];

        if (!targetElement) {
            return;
        }

        // Data is keyed by field name (e.g. "gtin", "batch", "expDate"). Find the entry whose Application Identifier matches.
        var parsedCodeItem = Object.values(parsedResult.data).find(function (item) {
            return item.ai === applicationIdentifier;
        });

        if (!parsedCodeItem) {
            return;
        }

        if (targetElement.getAttribute("format") === "date") {
            setReadOnlyDate(targetElement, parsedCodeItem.data);
        } else {
            // Show the '(' and ')' characters with Private Use Characters that were temporarily hidden to prevent the library from conflicting with them.
            targetElement.value = parsedCodeItem.data.toString().replace(/\uE000/g, '(').replace(/\uE001/g, ')');
        }

        handleOnChange(targetElement);
    });

    document.dispatchEvent(new CustomEvent('barcodeValuesFilled'));
}


function digitalLinkToGs1Barcode(link) {
    const groupSeparator = String.fromCharCode(29);

    try {
        const url = new URL(link);

        const pathParts = url.pathname.split('/').filter(Boolean);
        const segments = [];

        for (let i = 0; i < pathParts.length; i += 2) {
            segments.push({ ai: pathParts[i], value: pathParts[i + 1] ?? '' });
        }

        for (const [key, value] of url.searchParams.entries()) {
            segments.push({ ai: key, value });
        }

        return segments.map((segment, idx) => {
            let part = segment.ai + segment.value;
            if (idx < segments.length - 1) {
                part += groupSeparator;
            }
            return part;
        }).join('');

    } catch (e) {
        return null;
    }
}

function replaceGs1Separators(input) {
    return input.split('').map(char =>
        gs1Separators.includes(char) ? String.fromCharCode(29) : char
    ).join('');
}

function dateHandleOnChange() {
    const vanillaElement = this.element.get(0);
    handleOnChange(vanillaElement);
}

/*
 * Messages
 */

var dialogCounter = 0;

function closeMessageDialog(id, dialogCounter) {
    var question = $("*[bq=\"" + messages[id].copyToQuestionBase + "\"]");
    var value = question.val();
    var isFirstMessage = !value;
    var rawMessage = messages[id].message;
    var safeMessageHtml = core.sanitizeHtml(core.xmlDecode(rawMessage));

    if (isFirstMessage) {
        var parent = question.parent();

        if (parent.hasClass("grow-wrap")) {
            // Fixes layout issue in multi-line text inputs.
            parent.removeClass("grow-wrap");
        }

        question.val(rawMessage);
        question.hide();
        question.after("<div class=\"msg form-control\" readonly>" + safeMessageHtml + "</div>");
    }
    else {
        question.val(value + core.xmlEncode("<hr/>") + rawMessage);

        var display = question.next(".msg");
        display.append("<hr/>" + safeMessageHtml);
    }

    $(".msgdialog").eq(dialogCounter).data("kendoWindow").close();
}

function checkMessage(obj, init) {
    try {
        var initialized = [];

        for (var i = 0; i < messages.length; i++) {
            if (init) {
                var copyToQuestion = messages[i].copyToQuestionBase;

                if (copyToQuestion === +$(obj).attr("bq") && $("*[bq=\"" + copyToQuestion + "\"]").val() && initialized.indexOf(copyToQuestion) === -1) {
                    var questionEl = $("*[bq=\"" + copyToQuestion + "\"]");
                    var parent = questionEl.parent();

                    if (parent.hasClass("grow-wrap")) {
                        // Fixes layout issue in multi-line text inputs.
                        parent.removeClass("grow-wrap");
                    }

                    var msg = questionEl.val();
                    if (msg.indexOf("<") > -1) {
                        questionEl.val(core.xmlEncode(msg));
                    }

                    var safeMessageHtml = core.sanitizeHtml(core.xmlDecode(msg));
                    questionEl.hide();
                    questionEl.after("<div class=\"msg form-control\" readonly>" + safeMessageHtml + "</div>");
                    initialized.push(copyToQuestion);
                }
            } else if (messages[i].questionBase === +$(obj).attr("bq")
                && validation.validateValueCompare({ leftValue: $(obj).val(), operator: messages[i].operator, rightValue: messages[i].value })) {

                var win = $("<div id=\"msgdialog\" class=\"msgdialog\"></div>");
                $("#windowcontainer").append(win);

                var msgWindow = $("#msgdialog").kendoWindow({
                    visible: false,
                    height: coreUI.getPopupHeight(700),
                    width: coreUI.getPopupWidth(900),
                    title: i,
                    modal: true,
                    iframe: true,
                    deactivate: function () {
                        this.destroy();

                        // No more message dialogs.
                        if ($(".msgdialog").length === 0) {
                            $("body").css("overflow", "");
                            dialogCounter = 0;
                        }
                    },
                    actions: {},
                    refresh: function () {
                        var msgid = parseInt(this.title());
                        var msgno = messages.length - msgid;
                        var rawMessage = messages[msgid].message;
                        var safeMessage = core.sanitizeHtml(core.xmlDecode(rawMessage));
                        var messageContainer = this.element.children(".k-content-frame").contents().find(".lf-message");
                        var title = resources.messageTitle + " " + msgno + "/" + messages.length;

                        this.title(title);
                        messageContainer.html(safeMessage);
                    },
                }).data("kendoWindow");

                msgWindow.refresh({
                    url: baseUrl + "/Dialogs/MessageDialogFrame?id=" + i + "&idx=" + dialogCounter
                });

                // Dialog opened.
                dialogCounter++;

                $("body").css("overflow", "hidden");
                msgWindow.center().open();
            }
        }
    }
    catch (err) {
        console.error(err);
    }
}

/*
 * Date calculation
 */

function setDateValue(el, _date, amount, amountfield, unit) {
    if (parseInt(amountfield, 10) !== -1) {
        var fld = $("[bq=\"" + amountfield + "\"]").get(0);

        if (fld.tagName === "INPUT" && fld.type === "radio") {
            fld = $("[bq=\"" + amountfield + "\"]:checked").get(0);
        }

        if (!fld) {
            return false;
        }

        var fieldAmount = null;
        if (fld.tagName === "INPUT" && fld.type === "text") {
            fieldAmount = $(fld).val();
        }

        if (fld.tagName === "INPUT" && fld.type === "radio") {
            if (fld.getAttribute("alt") != null && fld.getAttribute("alt") != "") {
                fieldAmount = fld.getAttribute("alt");
            }
            else if (fld.getAttribute("text") != null && fld.getAttribute("text") != "") {
                fieldAmount = fld.getAttribute("text");
            }
            else {
                fieldAmount = fld.text;
            }
        }

        if (fld.tagName === "SELECT") {
            var selectedOption = $(fld).children().eq(fld.selectedIndex);
            if (selectedOption.length) {
                if (selectedOption.data("alt") != "") {
                    fieldAmount = selectedOption.data("alt");
                } else {
                    fieldAmount = selectedOption.text();
                }
            }
        }

        amount = parseInt(fieldAmount);
    }

    if (isNaN(amount)) {
        return false;
    }

    switch (unit) {
        case "1": { _date.addMinutes(amount); break; }
        case "2": { _date.addHours(amount); break; }
        case "3": { _date.addDays(amount); break; }
        case "4": { _date.addMonths(amount); break; }
        case "5": { _date.addYears(amount); break; }
    }

    var dateWidgetType = datePickerMap[$(el).attr("data-role")];
    if (dateWidgetType) {
        $(el).data(dateWidgetType).value(_date);
    }
    else {
        setReadOnlyDate(el, _date);
    }
}

function setReadOnlyDate(element, date) {
    var displayDate = date.getDate() + "-" + (date.getMonth() + 1) + "-" + date.getFullYear();
    var displayTime = pad(date.getHours(), 2) + ":" + pad(date.getMinutes(), 2);
    var dateType = $(element).attr("datetype");

    if (dateType === "0") {
        $(element).val(displayDate);
    }
    else if (dateType === "1") {
        $(element).val(displayTime);
    }
    else if (dateType === "2") {
        $(element).val(displayDate + " " + displayTime);
    }
}

function pad(num, size) {
    var s = num + "";
    while (s.length < size) {
        s = "0" + s;
    }

    return s;
}

function changeDependentDate(triggerEl) {
    var baseId = triggerEl.getAttribute("bq");

    if (dateTriggers.indexOf(baseId) === -1) {
        return;
    }

    var isAmountField = false;
    var dateFields = $("input[field=\"" + baseId + "\"]");

    if (dateFields.length === 0) {
        dateFields = $("[amountfield=\"" + baseId + "\"]");
        isAmountField = true;
    }

    var $sourceEl = isAmountField ? $() : $(triggerEl);

    for (var i = 0; i < dateFields.length; i++) {
        var targetField = dateFields[i];
        var $targetField = $(targetField);
        var sourceBaseId = $targetField.attr("field");

        if (isAmountField) {
            $sourceEl = $("[bq=\"" + sourceBaseId + "\"]");
        }

        var sourceType = datePickerMap[$sourceEl.attr("data-role")];
        var sourceDate;

        if (!sourceBaseId || sourceBaseId === "-1") {
            // Source is current date.
            sourceDate = new Date();
        }
        else if (sourceType) {
            // Source is date picker.
            var datePickerDate = $sourceEl.data(sourceType).value();

            // Don't calculate with invalid date in source date picker.
            if (datePickerDate) {
                sourceDate = datePickerDate;
            }
        }
        else {
            // Source is readonly field or datepicker that is not initialised.
            var sourceValue = $sourceEl.val();

            if (dating.isDateStr(sourceValue) === "") {
                sourceDate = dating.getDateFromString(sourceValue);
            }
        }

        if (sourceDate) {
            var amount = parseInt($targetField.attr("amount"));
            var amountfield = $targetField.attr("amountfield");
            var unit = $targetField.attr("unit");

            setDateValue(targetField, new Date(sourceDate), amount, amountfield, unit);
        }
    }
}

/*
 * Formula
 */
var vCacheEls = {};

function vCache(id) {
    var cached = vCacheEls[id];

    if (!cached) {
        cached = document.getElementById(id);

        if (!cached) {
            // Radio button.
            var options = document.querySelectorAll(`input[id^="${id}_"]`);

            if (!options.length) {
                // Checkbox.
                options = document.querySelectorAll(`input[id^="${id}#"]`);
            }

            if (options.length) {
                cached = Array.from(options);
            } else {
                // Element does not exist or has no options.
                cached = "no-cache";
            }
        }

        // Add to cache.
        vCacheEls[id] = cached;
    }

    return cached;
}

function getFormulaValue(str, customDefaultValue) {
    // Used by formulas to get question value.
    var hasCustomDefaultValue = typeof customDefaultValue === "number";
    var defaultValue = hasCustomDefaultValue ? customDefaultValue : "";
    var alternateDefaultValue = hasCustomDefaultValue ? customDefaultValue : undefined;

    try {
        if (str === "id_-1") {
            return defaultValue;
        }

        var val = '';
        var el = vCache(str);

        if (el === "no-cache") {
            return alternateDefaultValue;
        }

        if (Array.isArray(el)) {
            // Radio button or checkbox.
            var type = el[0].type;

            if (type === "radio") {
                var selectedRadio = el.find(function (radio) {
                    return radio.checked;
                });

                if (!selectedRadio) {
                    // No option selected.
                    return alternateDefaultValue;
                }

                val = selectedRadio.getAttribute("alt");
            } else if (type === "checkbox") {
                var checkedCheckboxes = el.filter(function (checkbox) {
                    return checkbox.checked;
                });

                if (!checkedCheckboxes.length) {
                    // Nothing is checked.
                    return alternateDefaultValue;
                }

                // Sum values.
                val = checkedCheckboxes
                    .map(function (checkbox) {
                        return parseFloat(checkbox.getAttribute("alt")) || 0;
                    })
                    .reduce(function (total, value) {
                        return total + value;
                    }, 0)
                    .toString();
            } else {
                return alternateDefaultValue;
            }
        } else if ((el.tagName === "INPUT" && el.type === "text") || el.tagName === "TEXTAREA") {
            val = el.value;
        } else if (el.tagName === "SELECT") {
            var selectedOption = $(el).children().eq(el.selectedIndex);

            if (selectedOption.length) {
                var optionAlt = selectedOption.data("alt");
                if (typeof optionAlt !== "undefined" && optionAlt !== "") {
                    // jQuery casts to number if possible, val has to be string for isDateStr().
                    val = optionAlt + "";
                }
                else {
                    val = selectedOption.text();
                }
            }
        }

        if (dating.isDateStr(val) === "") {
            return dating.getDateFromString(val);
        }
        else {
            var numericVal = parseFloat(val);

            if (isNaN(numericVal)) {
                return defaultValue;
            }
            else {
                return numericVal;
            }
        }
    }
    catch (ex) {
        console.error(str, ex);
    }
}

var formulaCache = {};

function calc(triggerId) {
    var triggeredFormulas = formulaTriggers[triggerId];

    if (!triggeredFormulas) {
        return;
    }

    triggeredFormulas.forEach(function callCalculate(formulaId) {
        var f = formulaCache[formulaId];
        calculateFormula(f);
    });
}

function calculateFormula(f) {
    var result = 0;

    try {
        result = +eval(f.formula) || 0;
    }
    catch (ex) {
        return handleFormulaError(f.id, ex);
    }

    var decimals = f.decimals;
    var currentVal = f.element.val();

    if (decimals < 0 || decimals > 100) {
        decimals = 0;
    }

    if (result.toFixed(decimals) !== currentVal) {
        f.element.val(result.toFixed(decimals));

        var vanillaElement = f.element.get(0);
        handleOnChange(vanillaElement);
    }
}

function initFormulaCache() {
    $("input.formula").each(function () {
        var element = $(this);
        var decimals = parseInt(element.attr("decimals"), 10);
        var formula = element.attr("formule");
        var id = element.attr("name");

        formulaCache[id] = {
            id: id,
            element: element,
            decimals: decimals,
            formula: formula
        };
    });
}

function initCalc() {
    initFormulaCache();

    for (var formulaId in formulaCache) {
        var formula = formulaCache[formulaId];
        calculateFormula(formula);
    }
}

var erroredFormulas = [];

function handleFormulaError(id, exception) {
    if (erroredFormulas.indexOf(id) > -1) {
        return;
    }

    erroredFormulas.push(id);

    core.notify("error", resources.formulaErrorMessage);
    console.error("Error calculating formula. Id " + id, exception);
}

/*
 * Rights
 */
var rightActions = {
    deny: 0,
    allow: 1,
    forcedDeny: 2
};

/**
 * Validates rights based on a trigger ID and value.
 * @param {string} triggerId - The ID of the trigger element.
 * @param {string} val - The value to validate against.
 * @param {boolean} isCheckbox - Whether the trigger is a checkbox.
 * @returns {Array} Array of checked rights with their matching status.
 */
function validateRights(triggerId, val, isCheckbox) {
    var triggeredRights = rights[triggerId];

    if (!triggeredRights) {
        return [];
    }

    var checkedRights = triggeredRights.map(function (right) {
        var matched = false;
        if (isCheckbox) {
            var values = val.split(";");

            for (var i = 0; i < values.length; i++) {
                matched = validation.validateValueCompare({ leftValue: values[i], operator: right.operator, rightValue: right.value });
                if (matched) {
                    break;
                }
            }
        }
        else {
            matched = validation.validateValueCompare({ leftValue: val, operator: right.operator, rightValue: right.value });
        }

        var newAction = right.action;
        if (!matched) {
            if (right.action === rightActions.allow) {
                newAction = rightActions.deny;
            }
            else {
                newAction = rightActions.allow;
            }
        }

        return {
            uniqueTargetId: right.targetType + "-" + right.targetId,
            targetId: right.targetId,
            targetType: right.targetType,
            right: right.right,
            action: newAction
        };
    });

    var toDelete = checkedRights.reduce(function (accu, right) {
        if (right.action === rightActions.forcedDeny) {
            accu.forcedDeny.push(right.uniqueTargetId);
        }

        if (right.action === rightActions.allow) {
            accu.deny.push(right.uniqueTargetId);
        }

        return accu;
    }, { deny: [], forcedDeny: [] });

    var matchedRights = checkedRights.filter(function (right) {
        if (right.action === rightActions.deny && toDelete.deny.indexOf(right.uniqueTargetId) > -1) {
            return false;
        }

        if (right.action !== rightActions.forcedDeny && toDelete.forcedDeny.indexOf(right.uniqueTargetId) > -1) {
            return false;
        }

        return true;
    });

    return matchedRights;
}

function getValue(sender) {
    var result = {
        id: sender.id.split("_")[1],
        isCheckbox: false,
        value: ""
    };

    if (sender.type === "checkbox") {
        if (result.id.split("#").length > 1) {
            $("input[name^=\"" + result.id.split("#")[0] + "#\"]:checked").each(function () {
                if (result.value !== "") {
                    result.value += ";";
                }

                result.value += this.id.split("#")[1];
            });
        }
        else {
            if ($(sender).is(":checked")) {
                result.value = "0";
            }
        }

        result.isCheckbox = true;
        result.id = result.id.split("#")[0];
    }
    else if (sender.type === "radio") {
        // TODO: use id instead?
        result.value = $("input[name=\"" + sender.name + "\"]:checked").val();

        // TODO: remove this line? it shouldn't be able to do anything.
        result.id = result.id.split("_")[0];
    }
    else {
        result.value = $(sender).val();
    }

    return result;
}

function checkRights(sender, init) {
    var senderData = getValue(sender);
    var activeRights = validateRights(senderData.id, senderData.value, senderData.isCheckbox);

    if (activeRights.length === 0) {
        return;
    }

    for (var i = 0; i < activeRights.length; i++) {
        var right = activeRights[i];
        var affectedId = right.targetId;
        var rightType = right.right;
        var rightAction = right.action;
        var uniqueTargetId = right.uniqueTargetId;

        var affectedType = right.targetType;
        var isPart = affectedType === "formpart";
        var isQuestion = affectedType === "question";
        var isPartDisabled = false;

        if (isPart) {
            $trg = $("#FP_" + affectedId);
        }
        else if (isQuestion) {
            $trg = $("#q-container-" + affectedId);
            var parentPart = $trg.parent();
            isPartDisabled = parentPart.data("partdisabled") === "true";
        }

        if (isDataCorrector) {
            $trg.removeClass("hidden");
            $trg.find(".q-input *").removeAttr("disabled");
            continue;
        }

        var matchedForcedDeny = forcedDenyRights[uniqueTargetId];
        var forcedDeny = matchedForcedDeny && matchedForcedDeny.some(function (f) {
            var element = document.getElementById("id_" + f.sourceId);

            if (!element) {
                return false;
            }

            if (validation.validateValueCompare({ leftValue: getValue(element).value, operator: f.operator, rightValue: f.value })) {
                return true;
            }
        });

        if (rightType === 2) {
            if (rightAction === rightActions.allow && !forcedDeny) {
                $trg.removeClass("hidden");
            }
            else if (rightAction === rightActions.deny || rightAction === rightActions.forcedDeny || forcedDeny) {
                $trg.addClass("hidden");
            }
        }
        else if (rightType === 1) {
            if (rightAction === rightActions.allow && !isPartDisabled && !forcedDeny) {
                toggleQuestions($trg, true);
            }

            if (rightAction === rightActions.deny || rightAction === rightActions.forcedDeny || forcedDeny) {
                toggleQuestions($trg, false);
            }
        }

        if (isPart) {
            if ($trg.children(".question-container").not(".hidden").length === 0) {
                $trg.addClass("hidden");
            }
        }
    }
}

function toggleQuestions(container, state) {
    container.find(".q-input").each(function () {
        var $q = $(this);
        var type = +this.getAttribute("data-type");

        // TODO: add formula?
        if (type === formControls.questionTypes.text) {
            $q.find("input, button, textarea").prop("disabled", !state);
        }
        else if (type === formControls.questionTypes.checkbox || type === formControls.questionTypes.radioButton) {
            $q.find("input").prop("disabled", !state);
        }
        else if (type === formControls.questionTypes.dropdown) {
            $q.find("select").prop("disabled", !state);
        }
        else if (type === formControls.questionTypes.matrix) {
            toggleQuestion.matrix($q, state);
        }
        else if (type === formControls.questionTypes.dateTime) {
            toggleQuestion.date($q, state);
        }
        else if (type === formControls.questionTypes.attachment) {
            toggleQuestion.attachment($q, state);
        }
        else if (type === formControls.questionTypes.inspectionPoint) {
            toggleQuestion.inspectionPoint($q, state);
        }
        else if (type === formControls.questionTypes.drawing) {
            toggleQuestion.drawing($q, state);
        }
    });
}

var toggleQuestion = {
    date: function toggleDateInput(container, state) {
        var input = container.find("input");
        var role = input.attr("data-role");
        var type = datePickerMap[role];
        if (type) {
            input.data(type).enable(state);
        }
        else {
            input.prop("disabled", !state);
        }
    },
    matrix: function toggleMatrix(container, state) {
        var matrixContainer = container.parent().next();

        matrixContainer.find(".matrix-data").data("rightsDisabled", !state);
        matrixContainer.find("button, .drag-indicator").toggleClass("hidden", !state);
        matrixContainer.find(".matrixView").toggleClass("hidden", state);
    },
    attachment: function toggleAttachment(container, state) {
        var input = container.find("input");

        // Kendo only sets k-disabled class on wrapper and disabled state on input.
        // Input may not be present if value is from dataset.
        input.data("kendoUpload")?.enable(state);
        input.prop("disabled", !state);

        container.parent().next().find(".attachments-container").toggleClass("hide-attachment-buttons", !state);
    },
    inspectionPoint: function toggleInspectionPoint(container, state) {
        container.find("button").toggleClass("hidden", !state);
        container.find("input").prop("disabled", !state);

        // Set state on cards container to communicate if editing is allowed?
        // container.parent().next();
        // matrixContainer.find(".matrix-data").data("rightsDisabled", !state);
    },
    drawing: function toggleCanvas(container, state) {
        container.find(".canvas-container").toggleClass("disabled-drawing", !state);
        container.find(".clear-drawing").prop("disabled", !state);
        var $canvas = container.find("canvas:first-of-type");

        if (!$canvas.hasClass("lower-canvas")) {
            // Doesn't work with prop.
            $canvas.attr("disabled", !state);
            return;
        }

        var canvas = $canvas.get(0).fabric;
        canvas.isDrawingMode = state;

        if (!state) {
            canvas.forEachObject(function (o) {
                o.selectable = false;
            });
        }
    }
};

function initRights() {
    rightsInitOrder.forEach(function (id) {
        var rightsTrigger = document.getElementById("id_" + id);
        if (!rightsTrigger) {
            // Radio button.
            rightsTrigger = document.querySelector('input[id^=\'id_' + id + '_\']');
        }

        if (!rightsTrigger) {
            // Checkbox.
            rightsTrigger = document.querySelector('input[id^=\'id_' + id + '#\']');
        }

        checkRights(rightsTrigger, true);
    });
}

/*
 * Dataset
 */
function lookupDataset(questionId) {
    var questionInput = $("#id_" + questionId);
    var value = questionInput.val();
    var lineId = null;

    if (!value) {
        return;
    }

    loadDatasetRow(
        questionId,
        value,
        lineId,
        function () {
            getDataset(questionId, value);
        }
    );
}

function getDataset(questionId, filter) {
    $.ajax({
        url: baseUrl + "/api/SessionCheck/including-anonymous",
        type: "GET",
        success: function () {
            var formId = isMatrix ? parent.FORMID : FORMID;
            var formTypeId = isMatrix ? parent.FORMTYPEID : FORMTYPEID;
            var isNewForm = formId === "-1";
            var id = isNewForm ? formTypeId : formId;
            var url = baseUrl + "/Dialogs/ShowData?isNewForm=" + isNewForm.toString() + "&id=" + id + "&questionId=" + questionId + "&filter=" + (filter ? encodeURIComponent(filter) : "");
            var dialog = $("<div id=\"dialog\"></div>");
            $("#windowcontainer").append(dialog);
            $("body").css("overflow", "hidden");
            $("#dialog").kendoWindow({
                visible: false,
                height: coreUI.getPopupHeight(700),
                width: coreUI.getPopupWidth(1100),
                title: "Data",
                modal: true,
                close: function () {
                    $("body").css("overflow", "");

                    var keyField = $("#id_" + questionId);
                    if (keyField.val() !== keyField.data("selected")) {
                        keyField.val(keyField.data("selected"));
                    }
                },
                iframe: true,
                content: url,
                deactivate: function () {
                    this.destroy();
                }
            }).data("kendoWindow").center().open();
        },
        error: function (xhr) {
            if (xhr.readyState !== 0) {
                return leanformsNext.handleError();
            }

            core.notify("warn", resources.noNetworkMessage);
        }
    });
}

function loadDatasetRow(questionId, value, lineId, callback) {
    if (!value) {
        // Do not call the controller when no value is provided.
        return;
    }

    var formId = isMatrix ? parent.FORMID : FORMID;
    var formTypeId = isMatrix ? parent.FORMTYPEID : FORMTYPEID;
    var isNewForm = formId === "-1";
    var id = isNewForm ? formTypeId : formId;

    $.ajax({
        url: baseUrl + "/api/datasets/row-values?isNewForm=" + isNewForm.toString() + "&id=" + id + "&questionId=" + questionId + "&lineId=" + (lineId ? lineId : -1) + "&selectedValue=" + encodeURIComponent(value),
        error: leanformsNext.onAjaxError,
        success: function (response) {
            if (response.found !== 1) {
                if (typeof callback === "function") {
                    callback();
                    return;
                }
            }

            // Correct casing for manually entered value.
            if (response.keyValue !== value) {
                $("#id_" + questionId).val(response.keyValue).trigger("change");
            }

            // Store successfully selected value for undoing.
            $("#id_" + questionId).data("selected", response.keyValue);

            loadData({
                isDataset: true,
                data: response.fields,
                datasetData: {
                    keyFieldId: response.keyFieldId,
                    formGuid: response.formGuid
                }
            });
        }
    });
}

function closeDatasetDialog(questionId, value, lineId) {
    // Called from ShowData.
    $("#dialog").data("kendoWindow").close();
    $("#id_" + questionId).val(value).trigger("change");

    loadDatasetRow(questionId, value, lineId);
}

/*
 * Drawing
 */
var canvasMaxWidth = 500;
var canvases = [];

// Calculate (max)size for defined inline-size and padding (2 * 1.5rem). 
const formPadding = core.parseDimensionValue((2 * 1.5) + 'rem');
const minNeededWidth = core.parseDimensionValue('25rem') + formPadding;
let qInputWidth = getInputSize();

function getInputSize() {
    return [...document.querySelectorAll('.q-input')].find(element => core.isVisible(element)).offsetWidth;
}

function onResize() {
    formWidth = $(document).width();
    qInputWidth = getInputSize();

    canvases.forEach(resizeCanvas);
}

function resizeCanvas(canvas) {
    const currentMaxWidth = formWidth - formPadding;

    // Address resizing when available width for the canvas is smaller than the minNeededWidth.
    let width = currentMaxWidth < minNeededWidth ? currentMaxWidth : qInputWidth;

    if (width > canvasMaxWidth) {
        width = canvasMaxWidth;
    }

    var canvasWidth = canvas.getWidth();
    var ratio = canvasWidth / canvas.getHeight();
    var height = width / ratio;

    var scale = width / canvasWidth;
    var zoom = canvas.getZoom();

    zoom *= scale;

    canvas.setDimensions({ width: width, height: height });
    canvas.setViewportTransform([zoom, 0, 0, zoom, 0, 0]);
}

// Use a passive event listener for performance. Throttling could be used for further performance improvements.
window.addEventListener("resize", onResize, { passive: true });

function setBackground(canvas) {
    var rect = new fabric.Rect({
        x: 0,
        y: 0,
        rx: 0,
        ry: 0,
        fill: "#FFF",
        stroke: "#CCC",
        strokeWidth: 1,
        width: canvasMaxWidth - 1,
        height: 299,
        selectable: false
    });

    canvas.add(rect);
}

function clearCanvas(id) {
    $("#id_" + id).val("");
    delete changedDrawings[id];

    var canvas = document.getElementById("C_" + id).fabric;

    canvas.clear();
    setBackground(canvas);
    canvas.renderAll();
}

function createCanvas(id, readOnly) {
    $(function () {
        setTimeout(function () { delayedCreateCanvas(id, readOnly) }, 0);
    });
}

function delayedCreateCanvas(id, readOnly) {
    var canvasEl = document.getElementById(id);
    var $canvasEl = $(canvasEl);

    // Doesn't work with prop.
    var isDisabled = $canvasEl.attr("disabled");
    var state = $canvasEl.data("state");
    var drawingData = $canvasEl.data("drawing");
    var canDraw = state !== "saved" && !readOnly;
    var hasDrawing = Boolean(drawingData);

    var canvasConfig = {
        width: canvasMaxWidth,
        height: 300,
        renderOnAddRemove: false,
        hoverCursor: "default",
        selection: false,
        isDrawingMode: canDraw && !isDisabled
    };

    var canvas = new fabric.Canvas(id, canvasConfig);
    canvasEl.fabric = canvas;

    canvases.push(canvas);
    resizeCanvas(canvas);

    if (hasDrawing) {
        drawJSONOnCanvas(canvas, drawingData);
    }
    else {
        setBackground(canvas);
        canvas.renderAll();
    }

    if (canDraw) {
        canvas.on("mouse:down", onCanvasMouseDown);
        canvas.on("path:created", onCanvasPathCreate);
    }

    // Move canvasses 'under' the container border.
    canvas.lowerCanvasEl.style.left = '-1px';
    canvas.lowerCanvasEl.style.top = '-1px';
    canvas.upperCanvasEl.style.left = '-1px';
    canvas.upperCanvasEl.style.top = '-1px';

    // Make it possible to get focus style.
    canvas.wrapperEl.tabIndex = 0;

    // Disable focus style when disabled.
    canvas.wrapperEl.classList.toggle("disabled-drawing", isDisabled);
}

function drawJSONOnCanvas(canvas, json) {
    canvas.loadFromJSON(json, function canvasLoaded() {
        canvas.renderAll();
    }, function parseDrawing(jsonObject, fabricObject) {
        fabricObject.set("selectable", false);
    });
}

function onCanvasMouseDown(e) {
    if (!this.isDrawingMode) {
        return;
    }

    $(".form-fields").bind("touchmove", function (e) {
        e.preventDefault();
    });
}

function onCanvasPathCreate(e) {
    $(".form-fields").unbind("touchmove");

    const questionId = this.lowerCanvasEl.id.split("_")[1];
    const dataInput = document.querySelector("#id_" + questionId);
    const json = JSON.stringify(this);

    // Store.
    dataInput.value = json;
    changedDrawings[questionId] = this.toDataURL("jpeg");

    // When required, now data is set, thus hide the error.
    if (dataInput.hasAttribute("required")) {
        validation.hideError(dataInput);
    }

    // Redraw.
    drawJSONOnCanvas(this, json);
}

/**
 * Checks if any parent window has the 'is-offline' class on its body.
 * @returns {boolean} - True if any 'body' in the hierarchy has the 'is-offline' class.
 */
const hasOfflineClass = () => {
    for (let w = window; w;) {
        if (w.document.body?.classList.contains('is-offline')) {
            return true;
        }

        try {
            w = w === w.parent ? null : w.parent;
        }
        catch {
            break;
        }
    }

    return false;
};

/*
 * Matrix table
 */
function getMatrixLineButtons(dataInput, matrixQuestionId) {
    const rightsDisabled = dataInput.data("rightsDisabled");
    const matrixFormTypeId = dataInput.data("matrixFormTypeId");
    const forceHideEditButtons = dataInput.data("forceHideEditButtons");
    const showEditButtons = dataInput.data("showEditButtons") && !rightsDisabled;
    const editButtonsVisibility = showEditButtons ? "" : " hidden";
    const viewButtonVisibility = showEditButtons ? " hidden" : "";
    const isOffline = hasOfflineClass();

    let dragHandle = "";
    let editButton = "";
    let deleteButton = "";
    let viewButton = "";

    if (!forceHideEditButtons) {
        dragHandle = `
            <span class="drag-indicator lf-icon-drag-indicator${editButtonsVisibility}" draggable="true"></span>`;
        deleteButton = `
            <button type="button" class="button button-icon-only matrixRemove${editButtonsVisibility}" onclick="removeMatrixLine('${matrixQuestionId}')" title="${resources.matrix.removeLine}">
                <span class="button-icon lf-icon-delete"></span>
            </button>`;
        editButton = `
            <button type="button" class="button button-icon-only matrixEdit${editButtonsVisibility}" onclick="openMatrixPopup('${matrixQuestionId}', ${matrixFormTypeId}, 'edit')" title="${resources.matrix.editLine}">
                <span class="button-icon lf-icon-edit"></span>
            </button>`;
    }

    // Do not show view button when offline. Managing the editable state in the popup without the server's help is too difficult.
    if (!isOffline) {
        viewButton = `
            <button type="button" class="button button-icon-only matrixView${viewButtonVisibility}" onclick="openMatrixPopup('${matrixQuestionId}', ${matrixFormTypeId}, 'edit')" title="${resources.matrix.viewLine}">
                <span class="button-icon lf-icon-visibility"></span>
            </button>`;
    }

    return {
        dragHandle: dragHandle,
        delete: deleteButton,
        edit: editButton,
        view: viewButton
    };
}

/**
 * Determines the appropriate label for matrix calculation row.
 * Uses 'Total' if all calculations are addition (Sum) or none,
 * otherwise uses 'Result'.
 * @param {jQuery} headerCells - Matrix header cells
 * @returns {string} The label to use ('Total' or 'Result')
 */
function getMatrixCalculationLabel(headerCells) {
    const calculationTypes = [];

    headerCells.each(function (index) {
        if (index === 0) {
            // Skip first column (line number).
            return;
        }

        const header = $(this);
        const calc = parseInt(header.attr("calc")) || 0;

        if (calc > 0) {
            calculationTypes.push(calc);
        }
    });

    // If no calculations or all calculations are Sum (1), use 'Total'.
    if (calculationTypes.length === 0 || calculationTypes.every(calc => calc === 1)) {
        return resources.totalLabel;
    }

    // Otherwise use 'Result'.
    return resources.resultLabel;
}

/**
 * Builds the grid columns for a report matrix. The fields come from the header cells so the markup keeps describing them, the form number column gets
 * its link template and sort comparer here: the template keeps the url out of the cell, so the grid sorts and filters the column on the number instead
 * of on the url's guid, and the comparer sorts on the hidden form-id column, the same order a report sorts its Id on.
 * @param {any} headerCells The matrix table's header cells.
 * @param {boolean} hasCode True when the first column is the form number, which only a report matrix has.
 * @returns {any} The columns, or null for a matrix that is not a report matrix.
 */
function getReportMatrixColumns(headerCells, hasCode) {
    if (!hasCode) {
        return null;
    }

    return headerCells.toArray().map(function (headerCell) {
        const header = $(headerCell);
        const column = { field: header.attr("data-field"), encoded: false };

        if (header.attr("fldid") === "code") {
            column.template = "<a href=\"#: data['form-url'] #\">#: code #</a>";
            column.sortable = {
                compare: function (first, second) {
                    return Number(first["form-id"]) - Number(second["form-id"]);
                }
            };
        }

        return column;
    });
}

function redrawMatrix(dataInputId) {
    const dataInput = $("#" + dataInputId);

    const matrixQuestionId = +dataInput.attr("name");
    const buttons = getMatrixLineButtons(dataInput, matrixQuestionId);
    const allowDuplicateLine = dataInput.data("allowDuplicate");
    const matrixAddIsEnabled = dataInput.parent().find(".matrixAdd").is(":visible");

    var localAttachments = matrixAttachments[matrixQuestionId] || {};

    var matrixData = dataInput.val();
    if (matrixData && matrixData.indexOf("<") !== 0) {
        matrixData = core.xmlDecode(matrixData);
    }

    var matrix = leanformsNext.loadXml("<matrix>" + matrixData + "</matrix>");
    var lines = $(matrix).find("line");
    var lineCount = lines.length;

    var tableId = dataInputId.replace("md_", "id_");
    var table = $("#" + tableId);
    var headerCells = table.closest(".matrix-div").find("th");
    var hasCode = headerCells.eq(0).attr("fldid") === "code";

    table.find("tbody > tr").remove();

    headerCells.each(function () {
        var $this = $(this);

        if ($this.attr("tot") != "") {
            $this.attr("tot", "0");
        }
    });

    for (var ri = 0; ri < lineCount; ri++) {
        var line = lines.eq(ri);
        var lineId = line.attr("id");
        var lineAttachments = localAttachments[lineId];

        var lineNumber = ri + 1;

        var row = "<tr data-lineid='" + lineId + "' draggable='false'>";

        if (!hasCode) {
            row += `
                <td draggable="false">
                    ${lineNumber}
                    <div class="matrix-line-buttons-container">${buttons.dragHandle}${buttons.edit}${buttons.view}${buttons.delete}</div>
                </td>`;
        }

        headerCells.each(function () {
            row += getMatrixCell(this, line, lineAttachments).outerHTML;
        });

        row += "</tr>";
        table.find("tbody").append(row);
    }

    // Show or hide the duplicate button based on conditions.
    const duplicateButton = dataInput.parent().find(".matrix-duplicate-button");
    const enableDuplicateButton = matrixAddIsEnabled && allowDuplicateLine && lineCount > 0;

    if (allowDuplicateLine && matrixAddIsEnabled) {
        duplicateButton.prop("disabled", !enableDuplicateButton).removeClass("hidden");
    } else {
        duplicateButton.addClass("hidden");
    }

    var hasTotal = false;
    var matrixLabel = getMatrixCalculationLabel(headerCells);
    var totalRow = "<tr class='matrix-calculation-row' draggable='false'><td draggable=\"false\">" + matrixLabel + "</td>";

    headerCells.each(function (index) {
        if (index === 0) {
            return;
        }

        var header = $(this);
        var calc = header.attr("calc");
        var value = "";
        if (calc > 0) {
            hasTotal = true;

            var decimals = header.attr("dec");
            var total = header.attr("tot");
            var isAverage = calc === "3";

            if (isAverage) {
                value = total / lineCount;
            }
            else {
                value = Number(total);
            }

            if (parseInt(decimals) >= 0) {
                value = value.toFixed(decimals);
            }
        }

        totalRow += "<td draggable=\"false\">" + value + "</td>";
    });

    if (hasTotal && lineCount) {
        totalRow += "</tr>";

        table.find("tbody").append(totalRow);
    }

    var matrixGrid = table.data("kendoGrid");

    if (!matrixGrid) {
        const reportColumns = getReportMatrixColumns(headerCells, hasCode);
        const config = reportColumns
            ? $.extend({}, matrixConnectedFormsConfig, { columns: reportColumns })
            : matrixConnectedFormsConfig;

        matrixGrid = table.removeClass("k-grid k-table").kendoGrid(config).data("kendoGrid");
        initMatrixEvents(matrixGrid);
    }
    else {
        // Reinitialize sortable when matrix is redrawn.
        initMatrixSortable(matrixGrid);
    }

    for (var i = 0; i < headerCells.length; i++) {
        var header = headerCells.eq(i);

        matrixGrid.showColumn(i);

        if (header.hasClass("matrix-hidden-column") || header.hasClass("rights-hidden-column")) {
            // Only works correctly if we show the column first.
            matrixGrid.hideColumn(i);
        }
    }

    // matrixGrid.refresh();

    if ($("#grdActions")) {
        refreshActionGrid();
    }
}

function getMatrixCell(th, line, localAttachments) {
    var $th = $(th);
    var thid = $th.attr("fldid");
    var calc = +$th.attr("calc");
    var format = $th.attr("format");
    var cell = document.createElement("td");
    cell.setAttribute("draggable", "false");

    if ($th.hasClass("rights-hidden-column")) {
        return cell;
    }

    if (!thid) {
        return "";
    }

    var field = line.find("field[vraagid=\"" + thid + "\"]");
    var val = field.attr("display");

    if (!val) {
        val = "";

        var isCheckbox = $th.data("is-checkbox");
        if (isCheckbox) {
            if (field.attr("value") === "on") {
                // Before v3.4.? this was not set correctly, so it is corrected here,
                val = "[X]";
            }
            else {
                // Checkbox.
                var fields = $(line).find("[vraagid^=\"" + thid + "#\"]");
                var vals = $.map(fields, function (field) {
                    return $(field).attr("display");
                });

                val = vals.join("\n");
            }
        }
    }

    if (!val) {
        // TODO: Create elements instead of string.
        var attachments = "";

        if (localAttachments) {
            attachments = localAttachments
                .filter(function (attachment) {
                    return attachment.questionId === thid;
                })
                .map(function (attachment) {
                    var displayName = attachment.displayName;

                    if (attachment.guid || attachment.fileName) {
                        var url = baseUrl + "/api/attachments";
                        if (attachment.fileName) {
                            url += "?fileName=" + attachment.fileName;
                        }
                        else {
                            url += "?isNew=true&guid=" + attachment.guid;
                        }

                        url += "&displayName=" + encodeURIComponent(displayName);

                        return "<a href=\"" + url + "\" target=\"_blank\">" + core.htmlEncode(displayName) + "</a>";
                    }

                    return core.htmlEncode(displayName);
                })
                .join("<br />");
        }
        else {
            var files = $(line).find("file[id=\"" + thid + "\"]");
            files.each(function () {
                var file = $(this);
                var filename = file.attr("name");
                var displayName = file.attr("displayname");
                var filePath = "/api/attachments?fileName=" + encodeURIComponent(filename);

                if (displayName) {
                    filePath += "&displayName=" + encodeURIComponent(displayName);
                }

                if (!displayName) {
                    displayName = filename.split("_").slice(2).join("_");
                }

                if (attachments) {
                    attachments += "<br />";
                }

                attachments += "<a href=\"" + baseUrl + filePath + "\" download onclick=\"downloadFile(event)\">" + core.htmlEncode(displayName) + "</a>";
            });
        }

        cell.innerHTML = attachments;
    }

    if (val && calc) {
        var newTot = calculateTotal($th, val, calc);

        $th.attr("tot", newTot);
    }

    if (format === "email") {
        var mailA = document.createElement("a");
        mailA.href = "mailto:" + val;
        mailA.textContent = val;

        cell.appendChild(mailA);
    }
    else if (format === "link") {
        var a = document.createElement("a");
        a.target = "_blank";
        a.rel = "noreferrer";
        a.textContent = val;

        var url = field.attr("url");

        if (url) {
            a.href = url;
        } else if (/^(http:|https:)?\/\//i.test(val)) {
            a.href = val;
        }

        cell.appendChild(a);
    }
    else if (format === "drawing") {
        var text = val ? resources.viewForm.drawing : resources.viewForm.noDrawing;
        var label = document.createElement("i");
        label.textContent = text;

        cell.appendChild(label);
    }
    else if (val) {
        cell.textContent = val;
    }

    return cell;
}

function calculateTotal($th, val, calc) {
    var currentTotal = parseFloat($th.attr("tot"));

    // Sum or average.
    if (calc === 1 || calc === 3) {
        return currentTotal + parseFloat(val);
    }

    // Subtract.
    if (calc === 2) {
        return currentTotal - parseFloat(val);
    }
}

function initMatrixEvents(matrixGrid) {
    // Deselect any rows when clicked outside.
    document.body.addEventListener('click', (e) => {
        if (e.target.closest('.k-grid .k-table') !== matrixGrid.element[0]) {
            matrixGrid.clearSelection();
            disableButtons();
        }
    }, { capture: false });

    // On android button events in a KendoGrid even happen on buttons with 'display: none'.
    // The only reliable fix I could find is disabling the buttons ('pointer-events: none' did not work).
    function disableButtons() {
        const items = matrixGrid.items();

        for (let i = 0; i < items.length; i++) {
            const buttons = items[i].querySelectorAll('.matrix-line-buttons-container button');
            buttons.forEach(button => {
                button.setAttribute('disabled', 'disabled');
            });
        }
    }

    matrixGrid.bind("change", function () {
        // Reset after selection changed.
        disableButtons();

        // Enable buttons for selected row. Delay to prevent click event firing on touch.
        const selectedRow = this.select()[0];
        setTimeout(() => {
            if (selectedRow) {
                const buttons = selectedRow.querySelectorAll('.matrix-line-buttons-container button');
                buttons.forEach(button => {
                    button.removeAttribute('disabled');
                });
            }
        }, 0);
    });

    // Initialize sortable for matrix rows reordering.
    initMatrixSortable(matrixGrid);

    // Allow native touch scrolling inside the Kendo grid content.
    enableMatrixTouchScroll(matrixGrid);

    // Initial setup.
    disableButtons();
}

/**
 * Initializes sortable functionality for matrix rows to allow drag-and-drop reordering.
 * @param {kendo.ui.Grid} matrixGrid - The Kendo Grid instance for the matrix table.
 */
function initMatrixSortable(matrixGrid) {
    const tableElement = matrixGrid.element;
    const tableBody = tableElement.find("tbody");
    const dataInputId = tableElement[0].id.replace("id_", "md_");
    const dataInput = document.getElementById(dataInputId);

    // Destroy existing sortable if it exists.
    const existingSortable = tableBody.data("kendoSortable");
    if (existingSortable) {
        existingSortable.destroy();
    }

    // Initialize Kendo Sortable on the table body.
    tableBody.kendoSortable({
        filter: 'tr:not(.matrix-calculation-row):not(.k-grouping-row):not(.k-grid-norecords)',
        handler: '.drag-indicator',
        cursor: "move",
        hint: function (element) {
            // Clone the element and preserve all selected styling.
            var hint = element.clone();

            // Ensure selected classes are applied.
            hint.addClass("k-state-selected").addClass("k-selected");

            // Get computed color values from a selected row to apply to hint.
            var backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--grid-selected-background-color').trim();
            var textColor = getComputedStyle(document.documentElement).getPropertyValue('--text-color-inverted').trim();

            // Apply inline styles to match the selected row appearance.
            hint.css({
                "display": "table-row",
                "background-color": backgroundColor,
                "color": textColor,
                "width": element.outerWidth() + "px"
            });

            // Preserve width and styling of each cell.
            element.children().each(function (index) {
                var cell = hint.children().eq(index);
                var originalCell = $(this);

                cell.css({
                    "width": originalCell.outerWidth() + "px",
                    "height": originalCell.outerHeight() + "px",
                    "display": "table-cell",
                    "background-color": backgroundColor,
                    "color": textColor,
                    "vertical-align": originalCell.css("vertical-align"),
                    "padding": originalCell.css("padding")
                });

                // Apply first cell specific styling.
                if (index === 0) {
                    cell.css({
                        "padding": "calc(0.25rem + 0.5px)",
                        "font-size": "0"
                    });
                }
            });

            // Ensure buttons container is visible.
            hint.find(".matrix-line-buttons-container").css("display", "flex");

            return hint;
        },
        placeholder: function (element) {
            var placeholder = element.clone();

            // Make sure it visually matches a selected row with proper styling.
            placeholder.addClass("k-state-selected").addClass("k-selected").addClass("k-sortable-placeholder");

            return placeholder;
        },
        change(eventArgs) {
            const { oldIndex, newIndex, item } = eventArgs;
            const totalRows = tableBody.find('tr:not(.matrix-calculation-row)').length;

            // Prevent dropping below the last data row.
            if (newIndex >= totalRows) {
                return;
            }

            if (oldIndex !== newIndex) {
                // Get the line ID from the moved row.
                const lineId = item.attr("data-lineid");

                reorderMatrixLines(dataInput, oldIndex, newIndex);

                // Re-select the row after redraw using line ID.
                if (lineId) {
                    setTimeout(() => {
                        const rowToSelect = matrixGrid.tbody.find(`tr[data-lineid="${lineId}"]`);
                        if (rowToSelect.length) {
                            matrixGrid.select(rowToSelect);
                        }
                    }, 0);
                }
            }
        },
        end: function (e) {
            // Selection is now handled in the change event.
        },
        start: function (e) {
            // Remember if the dragged row was selected.
            e.sender.wasSelected = e.item.hasClass("k-state-selected") || e.item.hasClass("k-selected");
        },
    });
}

/**
 * Reorders matrix lines in the XML data and refreshes the matrix display.
 * @param {string} dataInput - The matrix data input element.
 * @param {number} oldIndex - The original index of the moved line.
 * @param {number} newIndex - The new index where the line should be placed.
 */
function reorderMatrixLines(dataInput, oldIndex, newIndex) {
    const matrixData = dataInput.value;

    if (!matrixData) {
        return;
    }

    const decodedData = matrixData.indexOf("<") !== 0 ? core.xmlDecode(matrixData) : matrixData;
    const matrix = leanformsNext.loadXml("<matrix>" + decodedData + "</matrix>");
    const lines = matrix.find("line");

    if (oldIndex >= lines.length || newIndex >= lines.length) {
        return;
    }

    // Remove the line from its current position.
    const movedLine = lines.eq(oldIndex).detach();

    // Insert the line at the new position.
    if (newIndex === 0) {
        matrix.find("matrix").prepend(movedLine);
    } else if (newIndex >= lines.length - 1) {
        matrix.find("matrix").append(movedLine);
    } else {
        const targetLine = matrix.find("line").eq(newIndex);
        movedLine.insertBefore(targetLine);
    }

    // Update the matrix data input with the new XML structure.
    setMatrixXMLToInput($(dataInput), matrix);

    // Redraw the matrix to reflect the new order.
    redrawMatrix(dataInput.id);
}

/*
 * Load form data
 */
async function loadData(options) {
    /*
     * Options contains the following data structure.
     * {
     *    guid: "string",
     *    matrix: {
     *        dataInputId: "string",
     *        index: integer
     *    },
     *    data: XML || Array[{ name: "string", value: "string" }],
     *    isFieldCopy: boolean,
     *    isCopy: boolean,
     *    isOffline: boolean,
     *    isDataset: boolean,
     *    datasetData: {
     *        keyFieldId: integer,
     *        formGuid: "string"
     *    }
     * }
     */
    const isCopy = options.isCopy;
    const isDataset = options.isDataset;
    const isFieldCopy = options.isFieldCopy;
    const isOffline = options.isOffline;

    let formatIsXml = true;
    let shouldRunEvents = false;
    let missingDropdownOption = false;
    let datasetField = null;

    let timeSpent = performance.now();

    let el;
    let att;

    if (options.matrix) {
        // Matrix line.
        const dataInput = window.parent.$("#" + options.matrix.dataInputId);

        const fullMatrixXml = leanformsNext.loadXml("<matrix>" + dataInput.val() + "</matrix>");
        const matrixLineXml = fullMatrixXml.find("line").eq(options.matrix.index);

        matrixQuestionId = +dataInput.attr("name");
        matrixLineId = +matrixLineXml.attr("id");

        var localAttachments = parent.matrixAttachments[matrixQuestionId] || {};
        var lineAttachments = localAttachments[matrixLineId];
        if (lineAttachments) {
            loadMatrixLocalAttachments(lineAttachments);
        }

        el = matrixLineXml.find("field");
        att = matrixLineXml.find("file");

        isSurvey = parent.isSurvey;
        if (isSurvey) {
            shouldRunEvents = true;
        }
    }
    else if (isFieldCopy) {
        shouldRunEvents = true;
        formatIsXml = false;

        el = options.data;
    }
    else if (isCopy) {
        shouldRunEvents = true;

        const xmlData = $(options.data);
        el = xmlData.find("field");
        att = xmlData.find("file");
    }
    else if (isDataset) {
        shouldRunEvents = true;
        formatIsXml = false;

        el = options.data;

        // Used when dataset is based on LeanForms reports.
        datasetField = options.datasetData.keyFieldId;

        const datasetGuidInput = $("#ds_" + datasetField);

        if (datasetGuidInput.length > 0) {
            datasetGuidInput.val(options.datasetData.formGuid);

            $("#btn_" + datasetField).show();
        }
    }
    else if (options.guid) {
        // Full form.
        showExportButtons();

        const formDataUrl = `${baseUrl}/api/forms/${options.guid}`;
        const formDataResult = await core.fetch({ url: formDataUrl });
        const formDataResultText = await formDataResult.text();
        const formDataXml = new window.DOMParser().parseFromString(formDataResultText, "text/xml");
        const $formDataXml = $(formDataXml);

        el = $formDataXml.find("field");
        att = $formDataXml.find("file");

        if ($formDataXml.find("form").attr("issurvey")) {
            isSurvey = true;
            shouldRunEvents = true;
        }
    }
    else if (isOffline) {
        // Full form not synced.
        formatIsXml = false;

        // Id's are numerical, contain # for check boxes.
        var questionIdRegex = /^[0-9#]+$/;

        // TODO: Should file_ inputs be loaded while offline? (only used for copying attachments?).
        el = options.data.filter(function (question) {
            return questionIdRegex.test(question.name) || question.name === "Code" || question.name.startsWith("file_");
        });
    }

    for (var idx = 0; idx < el?.length; idx++) {
        try {
            var md = null;
            var questionInput;
            var question = el[idx];
            var questionId;
            var questionValue;
            var questionAttachmentsFromDataset;

            if (formatIsXml) {
                questionId = question.getAttribute("vraagid");
                questionValue = question.getAttribute("value");
                questionAttachmentsFromDataset = question.getAttribute("attachments");
            }
            else {
                questionId = question.name;
                questionValue = question.value;
                questionAttachmentsFromDataset = question.attachments;
            }

            if (questionId === "Code") {
                $("#FormId").val(questionValue);
                $("#Code").val(questionValue);
            }
            else if (questionId.substring(0, 4) === "tot_") {
                questionInput = document.getElementById(questionId);

                questionInput.value = questionValue;
                questionInput = questionInput.previousSibling;
                questionInput.value = questionValue;
            }
            else if (questionId.startsWith("file_") && isOffline) {
                // Handles copied files.
                questionInput = document.getElementById(questionId);
                questionInput.value = questionValue;

                if (questionValue) {
                    questionId = questionId.slice("file_".length);
                    var explanation = $("<div>").addClass("help-block").text(resources.copiedAttachmentsOfflineExplanation);
                    $('#attachments_' + questionId).append(explanation);
                }
            }
            else if (questionId.startsWith("not-applicable_")) {
                questionInput = document.getElementById(questionId);

                // Set not applicable checkbox state.
                var isNotApplicable = questionValue === "true";
                questionInput.checked = isNotApplicable;

                // Set button disabled stated based on not applicable.
                // Does not conflict with rights, as right show/hide the button.
                var inspectionQuestionId = questionId.replace("not-applicable_", "");
                var inspectionButton = document.getElementById("id_" + inspectionQuestionId);
                inspectionButton.disabled = isNotApplicable;
            }
            else {
                questionInput = document.getElementById("id_" + questionId);

                if (!questionInput) {
                    // Get radio button.
                    questionInput = document.getElementsByName(questionId)[0];
                }

                if (!questionInput) {
                    // Get checkbox without options saved in old format.
                    questionInput = document.getElementById("id_" + questionId + "#-1");
                }

                if (!questionInput) {
                    // Still no input found, ignore the rest.
                    continue;
                }

                if (questionInput.tagName === "TABLE") {
                    md = "md_" + questionId;
                    questionInput = document.getElementById(md);
                }
                else if (questionValue && questionInput.getAttribute("iscanvas") === "true") {
                    var localAttachment = lineAttachments && lineAttachments.find(function (att) {
                        return att.questionId === questionId;
                    });

                    var isUnsavedMatrix = localAttachment && localAttachment.state !== "saved";
                    var canEdit = isOffline || isUnsavedMatrix || isCopy;

                    if (!canEdit) {
                        $("#btn_" + questionId).hide();
                    }

                    var canvasEl = $("#C_" + questionId);
                    var canvas = canvasEl.get(0).fabric;

                    if (!canEdit) {
                        canvasEl.data("state", "saved");
                    }

                    if (canvas) {
                        if (!canEdit) {
                            canvas.set({
                                hoverCursor: "default",
                                isDrawingMode: false
                            });

                            // Indicate 'disabled'.
                            if (canvas.wrapperEl) {
                                canvas.wrapperEl.classList.add('disabled');
                            }
                        }

                        drawJSONOnCanvas(canvas, questionValue);
                    }
                    else {
                        canvasEl.data("drawing", questionValue);
                    }

                    if (isCopy) {
                        changedDrawings[questionId] = canvas.toDataURL("jpeg");
                        canvasEl.data("state", "new");
                    }

                    if (questionAttachmentsFromDataset?.length > 0) {
                        var file = questionAttachmentsFromDataset[0];

                        if (file.isDrawing && $("#file_" + questionId).length == 0) {
                            var input = $("<input id=\"file_" + questionId + "\" name=\"file_" + questionId + "\" type=\"hidden\" />")

                            canvasEl.after(input);
                        }

                        $("#file_" + questionId).val(getCopiedFileObject(file.fileName, null, datasetField, true, false));
                    }
                }

                const questionDataType = +questionInput.closest('.q-input')?.getAttribute('data-type');
                const questionType = questionInput.type;
                const dateType = questionInput.getAttribute('datetype');

                if (questionDataType === formControls.questionTypes.inspectionPoint) {

                }
                else if (questionType === "checkbox") {
                    if (questionValue === "on") {
                        questionInput.checked = true;
                    }
                }
                else if (questionType === "radio") {
                    var selectRadioId = "id_" + questionInput.name + "_" + questionValue;
                    questionInput = document.getElementById(selectRadioId);

                    questionInput.checked = true;
                }
                else if (questionType === "select-one") {
                    var $dropdown = $(questionInput);
                    var optionExists = $dropdown.find("option[value=\"" + questionValue + "\"]").length;

                    if (isCopy && !optionExists) {
                        missingDropdownOption = true;
                    }

                    if (isFieldCopy && !optionExists && $dropdown.is("[readonly]")) {
                        // readonly attribute is not supported for <select> element, so we work around it by only loading a single option.
                        var originalOption = question.sourceElement.find(":selected");
                        $dropdown.find("option").replaceWith(originalOption.clone());
                    }

                    $dropdown.val(questionValue);
                }
                else if (questionType === "file") {
                    removeDatasetAttachments(questionId);

                    for (var i = 0; i < questionAttachmentsFromDataset.length; i++) {
                        var file = questionAttachmentsFromDataset[i];

                        var displayName = file.displayName;
                        var fileName = file.fileName;
                        var filePath = file.url;
                        if (displayName) {
                            filePath += "&displayName=" + encodeURIComponent(displayName);
                        }

                        var currentValue = $("#file_" + questionId).val();
                        $("#file_" + questionId).val(currentValue + '|' + getCopiedFileObject(fileName, displayName, datasetField, isDataset, isCopy));

                        setTimeout(previewCreatorFactory({
                            url: baseUrl + filePath,
                            fileName: fileName,
                            displayName: displayName || fileName,
                            questionId: questionId,
                            state: 'saved',
                            isDatasetValue: isDataset,
                            isCopy: isCopy,
                            datasetField: datasetField
                        }), 0);
                    }
                }
                else if (dateType === "0" || dateType === "1" || dateType === "2") {
                    if (dating.isDateStr(questionValue) === "") {
                        const parsedDate = dating.getDateFromString(questionValue);

                        // Are we a Kendo control?
                        const datePickerType = datePickerMap[questionInput.getAttribute("data-role")];
                        if (datePickerType) {
                            $(questionInput).data(datePickerType).value(questionValue);

                            const displayDate = parsedDate.getDate() + "-" + (parsedDate.getMonth() + 1) + "-" + parsedDate.getFullYear();
                            const displayTime = pad(parsedDate.getHours(), 2) + ":" + pad(parsedDate.getMinutes(), 2);

                            if (dateType === "0") {
                                $(questionInput).val(displayDate);
                            }
                            else if (dateType === "1") {
                                $(questionInput).val(displayTime);
                            }
                            else if (dateType === "2") {
                                $(questionInput).val(displayDate + " " + displayTime);
                            }
                        }
                        else {
                            questionInput.value = questionValue;
                        }
                    }
                }
                else {
                    questionInput.value = questionValue;

                    if (questionInput.nodeName === "TEXTAREA" && questionInput.parentElement?.classList.contains("grow-wrap")) {
                        questionInput.parentElement.dataset.replicatedValue = questionValue;
                    }

                    if (questionInput.getAttribute("format") === "number") {
                        validation.validateRangeState({ element: questionInput });
                    }

                    if (questionInput.classList.contains("dataset")) {
                        $(questionInput).data("selected", questionValue);

                        var formGuid = document.getElementById("ds_" + questionId)?.value;
                        var linkButton = $("#btn_" + questionId);

                        linkButton.toggle(!!formGuid);
                    }

                    if (md) {
                        redrawMatrix(md);
                    }
                }

                formControls.fillDependantList(questionInput, questionInput.getAttribute("name"), !shouldRunEvents);
            }
        }
        catch (e) {
            console.error(e);
        }

        if (questionInput) {
            if (shouldRunEvents) {
                handleOnChange(questionInput);
            }
            else {
                checkMessage(questionInput, true);
            }
        }
    }

    if (formatIsXml) {
        for (var i = 0; i < att.length; i++) {
            try {
                var file = att[i];
                var displayName = file.getAttribute("displayname");
                var fileName = file.getAttribute("name");
                var fileQuestionId = file.getAttribute("id");
                var routeStep = file.getAttribute("step");
                var isDatasetValue = file.getAttribute("isdatasetvalue");

                var filePath = "/api/attachments?fileName=" + encodeURIComponent(fileName);

                if (displayName) {
                    filePath += "&displayName=" + encodeURIComponent(displayName);
                }

                if (isCopy) {
                    var currentValue = $("#file_" + fileQuestionId).val();
                    $("#file_" + fileQuestionId).val(currentValue + "|" + getCopiedFileObject(fileName, displayName, null, false, isCopy));

                    if (!routeStep) {
                        routeStep = currentStep;
                    }
                }

                setTimeout(previewCreatorFactory({
                    url: baseUrl + filePath,
                    fileName: fileName,
                    displayName: displayName || fileName,
                    questionId: fileQuestionId,
                    state: "saved",
                    step: routeStep,
                    isDatasetValue: isDatasetValue,
                    isCopy: isCopy
                }), 0);
            }
            catch (e) {
                console.error(e);
            }
        }
    }

    if (missingDropdownOption) {
        core.notify("warn", resources.optionNotFoundMessage, { duration: 8 * 1000 });
    }

    initRights();

    // Load inspections when loading a form.
    if (options.guid && window.questionControllerRegistry?.has('inspectionpoint')) {
        const inspectionsController = await window.questionControllerRegistry?.getOrLoad('inspectionpoint');
        await inspectionsController?.loadAndDisplayInspectionCards();
    }

    console.log(`loadData took '${Math.round(performance.now() - timeSpent)}' ms.`);

    // Call function in custom script if the function exists
    if (typeof handleAfterLoad === "function") {
        handleAfterLoad();
    }

    // Only apply on iOS PWA environments.
    if (core.isIosPWA) {
        setTimeout(() => {
            setFormData();
        }, 100);
    }
}

/**
 * Shows the export buttons as soon as form data is present.
 */
function showExportButtons() {
    document.querySelector("#btnDefaultFormExport")?.closest("li").classList.remove("hidden");
    document.querySelector("#btnExportForm")?.closest("li").classList.remove("hidden");
}

function getCopiedFileObject(fileName, displayName, datasetField, fromDataset, isCopy) {
    return JSON.stringify({
        "fileName": fileName,
        "displayName": displayName,
        "datasetField": datasetField,
        "fromDataset": fromDataset,
        "isCopy": isCopy
    });
}

function removeDatasetAttachments(fileQuestionId) {
    var el = $("#file_" + fileQuestionId);
    var currentValue = el.val();
    var array = currentValue.split("|");

    var newArray = array.filter(function (item) {
        if (item == "") {
            return;
        }

        return !JSON.parse(item).fromDataset;
    });

    var value = newArray.join("|");
    el.val(value);

    $("#attachments_" + fileQuestionId + " .attachment-container").each(function () {
        if ($(this).data("isDatasetValue")) {
            $(this).remove();
        }
    });
}

function removeCopiedAttachments(fileQuestionId, fileName) {
    var el = $("#file_" + fileQuestionId);
    var currentValue = el.val();
    var array = currentValue.split("|");

    var newArray = array.filter(function (item) {
        if (item == "") {
            return;
        }

        return !(JSON.parse(item).fileName === fileName);
    });

    el.val(newArray.join("|"));
}

function loadMatrixLocalAttachments(attachments) {
    var offlineIds = [];

    attachments.forEach(function (attachment) {
        if (typeof attachment.offlineId !== "undefined") {
            return offlineIds.push(attachment.offlineId);
        }

        var file = attachment.data;
        var displayName = attachment.displayName;
        var guid = attachment.guid;
        var fileName = attachment.fileName;
        var questionId = attachment.questionId;
        var state = attachment.state;
        var routeStep = attachment.step;
        var isDatasetValue = attachment.isDatasetValue;
        var isCopy = attachment.isCopy;

        if (attachment.type === "drawing") {
            var canvas = $("#C_" + questionId);

            canvas.data("guid", guid);
            canvas.data("filename", fileName);

            if (file) {
                changedDrawings[questionId] = file;
            }

            return;
        }

        var url = "";
        if (fileName) {
            url = baseUrl + "/api/attachments?fileName=" + fileName + "&displayName=" + encodeURIComponent(displayName);
        }
        else if (guid) {
            url = baseUrl + "/api/attachments?isNew=true&guid=" + guid + "&displayName=" + encodeURIComponent(displayName);
        }
        else if (file && coreUI.isImage(displayName)) {
            url = getOfflineUrl(attachment.data);
        }

        var previewOptions = {
            url: url,
            state: state,
            displayName: displayName,
            questionId: questionId
        };

        if (file) {
            previewOptions.file = file;
        }

        if (isCopy) {
            previewOptions.isCopy = isCopy;
        }

        if (isDatasetValue) {
            previewOptions.isDatasetValue = isDatasetValue;
        }

        if (guid) {
            previewOptions.guid = guid;
        }

        if (fileName) {
            previewOptions.fileName = fileName;
            previewOptions.step = routeStep;
        }

        setTimeout(previewCreatorFactory(previewOptions), 0);
    });

    if (offlineIds.length) {
        loadOfflineAttachments(offlineIds);
    }
}

function loadOfflineAttachments(ids) {
    indexedDatabase.attachments
        .where(":id").anyOf(ids)
        .each(function (attachment) {
            var attachmentId = attachment.id;
            var questionId = attachment.questionId;

            if (attachment.type === "drawing") {
                $("#C_" + questionId).data("offline-id", attachmentId);

                return;
            }

            var displayName = attachment.displayName;
            var url = "";

            if (coreUI.isImage(displayName)) {
                url = getOfflineUrl(attachment.data);
            }

            createPreviewElement({
                url: url,
                offlineId: attachmentId,
                displayName: displayName,
                questionId: questionId,
                state: "new",
                offlineFormSaved: true
            });
        })
        .catch(leanformsNext.handleError);
}

function getOfflineUrl(data) {
    return URL.createObjectURL(data);
}

function previewCreatorFactory(options) {
    return function () {
        createPreviewElement(options);
    };
}

/*
 * Loading
 */
function setMatrixToolbar() {
    var formContainer = $(".form");

    formContainer.removeClass("not-matrix-form");
    formContainer.addClass("is-matrix-form");

    $(".matrix-toolbar-holder")
        .appendTo(".js-fixed-header")
        .show();
}

function tryLoadMatrixData() {
    if (!isMatrix) {
        return;
    }

    setMatrixToolbar();

    var index = +indexParam[1];
    var isNewMatrixLine = index === -1;
    if (isNewMatrixLine) {
        return;
    }

    var parentQuestionId = window.location.href.match(/&parent-question=(\d+)/)[1];

    loadData({
        matrix: {
            dataInputId: "md_" + parentQuestionId,
            index: index
        }
    });
}

function loadOfflineData() {
    if (OFFLINEID === -1) {
        return;
    }

    indexedDatabase.forms.get(OFFLINEID).then(function (form) {
        if (form.matrixAttachments) {
            form.matrixAttachments.forEach(function (matrix) {
                matrixAttachments[matrix.questionId] = {};

                matrix.lines.forEach(function (line) {
                    matrixAttachments[matrix.questionId][line.id] = line.attachments;
                });
            });
        }

        loadData({
            isOffline: true,
            data: form.data
        });

        loadOfflineAttachments(form.attachments);

        var actionParam = form.data.filter(function (item) {
            return item.name === "actions";
        })[0];

        if (actionParam && actionParam.value.length) {
            initActionsGrid({ offlineData: actionParam.value });
        }
    }).catch(leanformsNext.handleError);
}

async function loadFormData() {
    if (OFFLINEID !== -1) {
        loadOfflineData();

        return;
    }

    if (FORMGUID !== "00000000-0000-0000-0000-000000000000") {
        await loadData({
            guid: FORMGUID
        });

        eventBroadcaster.broadcast({ message: broadcasts.FORM_SAVED_DATA_LOADED });
    } else {
        tryLoadMatrixData();
    }
    
    if (!isMatrix) {
        await loadReportMatrices();
    }
}

$(function () {
    loadFormData();
});

/* 
 * Dataset based on reports.
 */
function openForm(guidInput) {
    window.open(baseUrl + "/ViewForm?FormGuid=" + guidInput.val(), "", "titlebar=no,location=no");
}

function openConnectedFromMatrix(e) {
    e.preventDefault();

    window.open(this.href.replace("?page=", ""), "", "titlebar=no,location=no");
}


/**
 * Download file(s) on iOS PWA.
 */
function downloadFile(event) {
    // Only apply on iOS PWA environments.
    if (!core.isIosPWA) {
        return;
    }

    event.preventDefault();

    // Check if the form is dirty.
    if (isDirty()) {
        // Create dialog.
        $("#windowcontainer").append('<div id="savecontinue-dialog"></div>');

        var saveContinueDialog = $("#savecontinue-dialog").kendoWindow({
            width: coreUI.getPopupWidth(550),
            height: coreUI.getPopupHeight(200),
            title: resources.viewForm.dirtyTitle,
            actions: {},
            visible: false,
            modal: true,
            iframe: false,
            resizable: false,
            deactivate: function () {
                this.destroy();
            },
        }).data("kendoWindow");

        saveContinueDialog.content(
            '<div class="popup-page popup-size-auto">' +
            '<div class="popup-content">' +
            resources.viewForm.dirtyText +
            '</div>' +
            '<div class="popup-toolbar">' +
            '<button type="button" id="btnCancel" class="button"><span class="button-icon lf-icon-cancel"></span><span>' + resources.viewForm.dirtyFalseLabel + '</span></button>' +
            '<button type="button" id="btnSaveContinue" class="button button-primary"><span class="button-icon lf-icon-check"></span><span>' + resources.viewForm.dirtyTrueSaveLabel + '</span></button>&nbsp;' +
            '</div>' +
            '</div>'
        );

        const dialogContent = document.querySelector("#savecontinue-dialog");
        dialogContent.querySelector("#btnSaveContinue").addEventListener("click", (e) => {
            // Save and download.
            sendForm("save", () => {
                const url = core.removeQueryParameter(top.window.location.href, "FormTypeId");

                // Update url, only when not containing a FormGuid.
                if (url.indexOf("FormGuid") === -1) {
                    const newUrl = core.setQueryParameter(url, "FormGuid", FORMGUID);
                    top.window.history.replaceState({ path: newUrl }, null, newUrl);
                }

                // Download file.
                core.downloadFileBlob(event);
                saveContinueDialog.close();
            });
        }, { capture: false });

        dialogContent.querySelector("#btnCancel").addEventListener("click", () => {
            saveContinueDialog.close();
        }, { capture: false });

        saveContinueDialog.center().open();
    }
    else {
        // Just download the file.
        core.downloadFileBlob(event);
    }
}

function getFormData() {
    const uploads = [...document.querySelectorAll('.attachment-text.display-name')].map(element => element.textContent).join(',');

    return $(".form").parent().find("input, select, textarea").serialize() + "," + uploads;
}

function setFormData() {
    savedFormData = getFormData();
}

function isDirty() {
    return savedFormData !== getFormData();
}
